import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
// TODO : 최신버전은 TreeView가 @mui/lab에서 @mui/x-tree-view로 이동했으나 기존 개발버전이 작동하지 않아 올드버전 사용
// -import { TreeView, TreeItem } from '@mui/lab';
// +import { TreeView, TreeItem } from '@mui/x-tree-view';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Stack,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import {
  CheckCircle,
  FactCheck,
  LockOpen,
  PostAdd,
  Visibility,
  TableChart,
  Help,
  Circle,
} from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { cloneDeep } from 'lodash';
import {
  AlertDialog,
  DialogTitleClose,
  PaperComponent,
} from "../dialog";
import {
  FormInputText,
} from "../form";
import { StyledTooltip } from "../tooltip";
import DocumentStatusLegend from './documentStatusLegend';
import * as gclientActions from "../../store/gclient";
import * as errorActions from "../../store/error";

import GProjectG04ContentTreeView from "./GProjectG04ContentTreeView";
import GProjectG04ContentTableView from "./GProjectG04ContentTableView";
import TestReportManagerDialog from './TestReport';

// const data = [
//   {
//     id: 'applications',
//     label: 'Applications',
//     // type: 'main',
//     children: [
//       {
//         id: 'applications.calendar',
//         label: 'Calender',
//         // type: 'sub',
//       },
//       {
//         id: 'applications.chrome',
//         label: 'Chrome',
//         // type: 'sub',
//       },
//       {
//         id: 'applications.webstorm',
//         label: 'Webstorm',
//         // type: 'sub',
//       },
//     ],
//   },
//   {
//     id: 'documents',
//     label: 'Documents',
//     // type: 'main',
//     children: [
//       {
//         id: 'documents.bootstrap',
//         label: 'Bootstrap',
//         // type: 'sub',
//         children: [
//           {
//             id: 'documents.bootstrap.button',
//             label: 'Button',
//             // type: 'cat',
//           },
//           {
//             id: 'documents.bootstrap.typography',
//             label: 'Typography',
//             // type: 'cat',
//           },
//         ],
//       },
//       {
//         id: 'documents.oss',
//         label: 'OSS',
//         // type: 'sub',
//       },
//       {
//         id: 'documents.material-ui',
//         label: 'Material UI',
//         // type: 'sub',
//         children: [
//           {
//             id: 'documents.material-ui.button',
//             label: 'Button',
//             // type: 'cat',
//           },
//           {
//             id: 'documents.material-ui.typography',
//             label: 'Typography',
//             // type: 'cat',
//           },
//           {
//             id: 'documents.material-ui.textfield',
//             label: 'Text Field',
//             // type: 'cat',
//           },
//         ],
//       },
//     ],
//   },
// ];
const prepareMaterialTableData = (gproject) => {
  const headers = [
    {
      type: 'HEADER',
      label: '구분',
      rowspan: 2,
      colspan: 2,
      hiddenSubHeaders: [
        { width: '10%', htmlWidth: '7%' },
        { width: '12%', htmlWidth: '8%' }
      ]
    },
    {
      type: 'HEADER',
      label: '제품명',
      rowspan: 2,
      // hiddenSubHeaders: [
      //   { width: '' },
      //   { width: '15%', htmlWidth: '15%' }
      // ]
    },
    {
      type: 'HEADER',
      label: '제조사',
      colspan: 5,
      subHeaders: [
        { label: '자재', width: '10%', htmlWidth: '12%' },
        { label: '배강도', width: '10%', htmlWidth: '12%' },
        { label: '강화', width: '10%', htmlWidth: '12%' },
        { label: '접합', width: '10%', htmlWidth: '12%' },
        { label: '복층', width: '10%', htmlWidth: '12%' }
      ]
    }
  ];

  const rows = (() => {
    // 유리 데이터
    const glassRows = gproject.selectedGlasses?.map(glass => {
      const items = [];
      let totalThickness = 0;

      glass.selectedGcomponentItems.forEach((layer) => {
        let glassProductName = null;
        let manufacturer = null;
        let thickness = null;
        let heatTreating = null;

        let idLaminated = null;
        let idInsulatedGlazing = null;
        
        layer.forEach((item) => {
          if (item.code === 'GLASS PRODUCT NAME') {
            glassProductName = item.value.name;
            manufacturer = item.value.gclients[0].name;
          } else if (item.code === 'GL THICKNESS') {
            thickness = item.value.code;
            totalThickness += parseFloat(thickness) || 0;
          } else if (item.code === 'GL HEAT TREATING') {
            heatTreating = item.value.code;
          } else if (item.code === 'FILM THICKNESS') {
            idLaminated = glass.id;
            totalThickness += parseFloat(item.value.code) || 0;
          } else if (item.code === 'SPACER THICKNESS') {
            idInsulatedGlazing = glass.id;
            totalThickness += parseFloat(item.value.code) || 0;
          }
        });
        
        let heatStrengthened = null;
        let tempered = null;

        if (heatTreating) {
          const getProcessInfo = (type) => {
            const process = glass.selectedProcessGClients.find(p => p.type === type);
            if (!process) return '';
            const thickness = process.specificationElements?.find(ele => ele.code === 'GL THICKNESS')?.value.code || '';
            return `${thickness}T\n${process.selectedGClients.map(client => client.name).join(", ")}`;
          };

          if (heatTreating === 'H/S') {
            heatStrengthened = getProcessInfo("HEAT_STRENGTHENED");
          } else if (heatTreating === 'F/T') {
            tempered = getProcessInfo("TEMPERED");
          }
        }
        
        if (glassProductName) {
          const product2 = `${thickness} ${glassProductName}\n${manufacturer}`;
          const existingItem = items.find(item => item.product2 === product2);
          
          if (existingItem) {
            if (heatStrengthened) existingItem.processing.HEAT_STRENGTHENED = heatStrengthened;
            if (tempered) existingItem.processing.TEMPERED = tempered;
          } else {
            items.push({
              id: `${glass.id}`,
              no: glass.no,
              product1: glass.specification || '',
              product2: product2,
              processing: {
                HEAT_STRENGTHENED: heatStrengthened,
                TEMPERED: tempered,
                LAMINATED: '',
                INSULATED_GLASS_UNIT: '',
              }
            });
          }
        } else {
          const getProcessInfo = (type) => {
            const process = glass.selectedProcessGClients.find(p => p.type === type);
            if (!process) return '';

            if (type === 'LAMINATED') {
              let filmType = '';
              let totalThickness = 0;
              
              process.specificationElements?.forEach(ele => {
                if (ele.code === 'FILM THICKNESS' || ele.code === 'GL THICKNESS' || ele.code === 'GL THICKNESS2') {
                  totalThickness += parseFloat(ele.value.code) || 0;
                } else if (ele.code === 'FILM TYPE') {
                  filmType = ele.value.name.replace(/\(.*?\)/, "");
                }
              });

              return `${totalThickness} ${filmType}\n${process.selectedGClients.map(client => client.name).join(", ")}`;
            } else if (type === 'INSULATED_GLASS_UNIT') {
              let totalThickness = 0;
              let gasMaterial = '';
              
              process.specificationElements?.forEach(ele => {
                if (ele.code === 'GL THICKNESS' || ele.code === 'GL THICKNESS2' || ele.code === 'SPACER THICKNESS') {
                  totalThickness += parseFloat(ele.value.code) || 0;
                } else if (ele.code === 'GAS MATERIAL') {
                  gasMaterial = ele.value.code;
                }
              });

              const gasText = gasMaterial === 'AR' ? ' 가스주입단열유리' : '';
              return `${totalThickness}T${gasText}\n${process.selectedGClients.map(client => client.name).join(", ")}`;
            }
          };

          if (idLaminated) {
            items.forEach(item => {
              if (item.id === idLaminated) {
                item.processing.LAMINATED = getProcessInfo("LAMINATED");
              }
            });
          }

          if (idInsulatedGlazing) {
            items.forEach(item => {
              if (item.id === idInsulatedGlazing) {
                item.processing.INSULATED_GLASS_UNIT = getProcessInfo("INSULATED_GLASS_UNIT");
              }
            });
          }
        }
      });

      return {
        type: 'RAW_MATERIAL',
        // id: glass.id,
        division1: `${totalThickness}T ${glass.gtypeName}`,
        items: items.length > 0 ? items : [{
          // id: glass.id,
          no: glass.no,
          product1: glass.specification || '',
          product2: '',
          processing: {
            HEAT_STRENGTHENED: '',
            TEMPERED: '',
            LAMINATED: '',
            INSULATED_GLASS_UNIT: '',
          }
        }]
      };
    });
    
    // 가공부자재 데이터 그룹화
    const processItems = gproject.selectedSubMaterialProcessItems?.filter(item => item.name && item.value && Object.keys(item.value).length > 0);
    
    const processGroup = Array.isArray(processItems) && processItems?.length > 0 ? [{
      type: 'SUB_MATERIAL_PROCESS',
      // id: 'process-group',
      division1: '가공부자재',
      items: processItems.map(item => ({
        // id: item.id,
        no: item.name,
        product1: item.value?.name || '',
        product2: item.value?.gclients?.[0]?.name || '',
        processing: {
          HEAT_STRENGTHENED: '',
          TEMPERED: '',
          LAMINATED: '',
          INSULATED_GLASS_UNIT: ''
        }
      }))
    }] : [];
    
    // 시공부자재 데이터 그룹화
    const buildItems = gproject.selectedSubMaterialBuildItems?.filter(item => item.name && item.value && Object.keys(item.value).length > 0);
    
    const buildGroup = Array.isArray(buildItems) && buildItems?.length > 0 ? [{
      type: 'SUB_MATERIAL_BUILD',
      // id: 'build-group',
      division1: '시공부자재',
      items: buildItems.map(item => ({
        // id: item.id,
        no: item.name,
        product1: item.value?.name || '',
        product2: item.value?.gclients?.[0]?.name || '',
        processing: {
          HEAT_STRENGTHENED: '',
          TEMPERED: '',
          LAMINATED: '',
          INSULATED_GLASS_UNIT: ''
        }
      }))
    }] : [];
    
    console.log(glassRows, processGroup, buildGroup);
    return [...(glassRows || []), ...(processGroup || []), ...(buildGroup || [])];
  })();

  return { headers, rows };
};

const prepareDocumentTableData = (itemsWithDocus, gproject, selected) => {
  const headers = [
    {
      type: 'HEADER',
      label: '구분',
      rowspan: 2,
      width: '6%',
    },
    {
      type: 'HEADER', 
      label: '업체명',
      rowspan: 2,
      width: '8%',
    },
    {
      type: 'HEADER',
      label: '일반서류',
      colspan: 7,
      subHeaders: [
        { label: '사업자\n등록증', width: '5%' },
        { label: '공장\n등록증', width: '5%' },
        { label: '국세', width: '5%' },
        { label: '지방세', width: '5%' },
        { label: '건설업\n등록증', width: '5%' },
        { label: '회사\n소개서', width: '5%' },
        { label: '기타', width: '6%' },
      ],
    },
    {
      type: 'HEADER',
      label: '기술문서',
      colspan: 6,
      subHeaders: [
        { label: '제품명' },
        { label: '인증서', colspan: 2 },
        { label: '성적서', width: '5%' },
        { label: '성과\n대비표', width: '5%' },
        { label: '기타', width: '6%' },
      ]
    }
  ];

  const transformRowDivisionData = [
    {
      id: 'SUPPLIER',
      label: '시공업체'
    },
    {
      id: 'RAW_MATERIAL',
      label: '원판'
    },
    {
      id: 'PROCESS',
      label: '가공'
    },
    {
      id: 'SUB_MATERIAL_PROCESS',
      label: '가공\n부자재'
    },
    {
      id: 'SUB_MATERIAL_BUILD',
      label: '시공\n부자재'
    }
  ];
  
  const generalDocus = [
    { label: '사업자등록증', required: true },
    { label: '공장등록증', required: true },
    { label: '국세 납세증명서', required: true },
    { label: '지방세 납세증명서', required: true },
    { label: '건설업등록증', required: gproject.contractType === 'PRIME' || gproject.contractType === 'SUBCONTRACT' }, // 건설업등록증은 원도급/하도급사만 제출해야 하는 필수서류임
    { label: '회사소개자료', required: false },
    { label: 'ETC', required: false },
  ];
  
  const rows = itemsWithDocus
    .filter(item => transformRowDivisionData.find(data => data.id === item.id))
    .flatMap(item => {
      const rowData = transformRowDivisionData.find(data => data.id === item.id);
      const companies = item.children?.map(child => {
        const generalDoc = child.children?.find(doc => doc.type === 'GENERALS'); // 일반서류
        
        const documentCells = generalDocus.map(docType => {
          const doc = generalDoc?.children?.find(doc => doc.label === docType.label);
          const isConstructionReg = docType.label === '건설업등록증';
          const isSupplier = rowData?.id === 'SUPPLIER';
          const isRequired = isConstructionReg ? 
            (isSupplier && (gproject.contractType === 'PRIME' || gproject.contractType === 'SUBCONTRACT')) : 
            docType.required;

          return {
            label: docType.label,
            hasPath: !!doc?.data?.documentPath,
            valid: doc?.data?.valid,
            validYN: doc?.data?.validYN,
            required: isRequired
          };
        });

        // 일반문서의 기타 문서 찾기 (generalDocus에 해당되지 않는 문서들)
        const otherDocs = generalDoc?.children?.filter(doc => 
          !generalDocus.some(d => d.label === doc.label)
        ).map(doc => ({
          label: doc.label,
          hasPath: !!doc.data?.documentPath,
          valid: doc.data?.valid,
          validYN: doc.data?.validYN
        })) || [];

        // 기타 문서가 있으면 마지막 컬럼에 문서 이름들을 나열
        if (otherDocs.length > 0) {
          documentCells[documentCells.length - 1] = otherDocs;
        }

        console.log('documentCells', documentCells);

        const certDoc = child.children?.find(doc => doc.type === 'CERTIFICATIONS'); // 인증서
        
        const testDoc = child.children?.find(doc => doc.type === 'TESTS'); // 성적서

        const etcDoc = child.children?.find(doc => doc.type === 'ETCS'); // 기타
        
        // 기술문서의 기타 문서 처리
        const etcDocs = [
          // CERTIFICATIONS 타입에서 g04GeneralDocuId가 있는 문서
          ...(certDoc?.children?.filter(doc => doc.data?.g04GeneralDocuId)?.map(doc => ({
            label: doc.label,
            hasPath: !!doc.data?.documentPath
          })) || []),
          // TESTS 타입에서 g04GeneralDocuId가 있는 문서
          ...(testDoc?.children?.flatMap(child => 
            child.children?.filter(doc => doc.data?.g04GeneralDocuId)?.map(doc => ({
              label: doc.label,
              hasPath: !!doc.data?.documentPath
            })) || []
          ) || []),
          // ETCS 타입의 기타 문서
          ...(etcDoc?.children?.map(doc => ({
            label: doc.label,
            hasPath: !!doc.data?.documentPath
          })) || []),
        ];

        // 제품명 목록 가져오기
        // RAW_MATERIAL: TESTS > children > children의 code와 label 조합
        // PROCESS: TESTS > children > children의 label
        // SUB_MATERIAL_PROCESS/BUILD: TESTS > children > children > children의 label과 상위 label 조합
        let productNames = [];
        if (rowData?.id === 'RAW_MATERIAL') {
          productNames = testDoc?.children?.flatMap(child => 
            (child.children || [])/*.filter(gchild => gchild.data.documentType === 'TEST')*/.map(doc => {
              // 인증서 노드에서 DOCCERTIFICATION 타입 노드 찾기
              const certificationDoc = certDoc?.children?.find(
                certDoc => certDoc.type === 'DOCCERTIFICATION' && 
                certDoc.data?.g04docuGCertificationId === doc.data?.g04docuGCertificationId
              );
              
              return {
                name: `${doc.data.code} ${child.label}`,
                hasDoc: !!doc.data?.documentPath,
                hasPerformanceDoc: !doc.data?.documentPath && !!doc.data?.performanceData?.performanceDocumentPath,
                hasComparisonDoc: !!doc.data?.gtestComparisonDocumentPath,
                g04docuGCertificationName: doc.data?.gstandardNo ? `[ ${doc.data?.gstandardNo} ]\n${doc.data?.g04docuGCertificationName}` : doc.data?.g04docuGCertificationName || '',
                hasCertificationDoc: !!certificationDoc?.data?.documentPath,
                isValid: doc.data?.valid,
                isValidYN: doc.data?.validYN,
                certificationId: doc.data?.g04docuGCertificationId
              };
            })
          ) || [];
        } else if (rowData?.id === 'PROCESS') {
          productNames = testDoc?.children?.flatMap(child => 
            (child.children || []).map(doc => {
              // 인증서 노드에서 DOCCERTIFICATION 타입 노드 찾기
              const certificationDoc = certDoc?.children?.find(
                certDoc => certDoc.type === 'DOCCERTIFICATION' && 
                certDoc.data?.g04docuGCertificationId === doc.data?.g04docuGCertificationId
              );
              
              return {
                name: doc.label,
                hasDoc: !!doc.data?.documentPath,
                hasPerformanceDoc: !doc.data?.documentPath && !!doc.data?.performanceData?.performanceDocumentPath,
                hasComparisonDoc: !!doc.data?.gtestComparisonDocumentPath,
                g04docuGCertificationName: doc?.data?.gstandardNo ? `[ ${doc?.data?.gstandardNo} ]\n${doc.data?.g04docuGCertificationName}` : doc.data?.g04docuGCertificationName || '',
                hasCertificationDoc: !!certificationDoc?.data?.documentPath,
                isValid: doc.data?.valid,
                isValidYN: doc.data?.validYN,
                certificationId: doc.data?.g04docuGCertificationId
              };
            })
          ) || [];
        } else if (rowData?.id === 'SUB_MATERIAL_PROCESS' || rowData?.id === 'SUB_MATERIAL_BUILD') {
          productNames = testDoc?.children?.flatMap(child => 
            child.children?.flatMap(subChild => 
              (subChild?.children || []).map(doc => {
                // 인증서 노드에서 DOCCERTIFICATION 타입 노드 찾기
                const certificationDoc = certDoc?.children?.find(
                  certDoc => certDoc.type === 'DOCCERTIFICATION' && 
                  (
                    // 시가공부자재의 경우 같은 표준이어도 인증규격(G04docuGCertifications)이 다를 수 있으므로 인증서가 여러개 포함될 수 있다.
                    // 그래서 중복된 인증서를 제거하는 로직이 목차 트리 구성할 때 있는데 이 때 삭제된 g04docuGCertificationId를 배열에 담아두어 아래처럼 찾을 때 사용했다.
                    certDoc.data?.g04docuGCertificationId === doc.data?.g04docuGCertificationId || 
                    (
                      certDoc.data?.g04docuGCertificationIds &&
                      Array.isArray(certDoc.data?.g04docuGCertificationIds) &&
                      certDoc.data?.g04docuGCertificationIds.length > 0 &&
                      certDoc.data?.g04docuGCertificationIds.includes(subChild.data?.g04docuGCertificationId)
                    )
                  )
                );

                return {
                  // 시가공부자재는 하위 스펙이 없는 경우 성적서 이름을 등록하는데 이때 성적서 이름을 입력하는 기준이 없다보니
                  // 보통 제품과 동일한 이름을 주게 되고 그럴 경우 같은 이름이 반복되므로 아래와 같이 처리
                  name: subChild?.label === doc.label ? subChild.label : `${subChild?.label} ${doc.label}`,
                  hasDoc: !!doc.data?.documentPath,
                  hasComparisonDoc: !!doc.data?.gtestComparisonDocumentPath,
                  g04docuGCertificationName: doc?.data?.gstandardNo ? `[ ${doc?.data?.gstandardNo} ]\n${doc.data?.g04docuGCertificationName}` : doc.data?.g04docuGCertificationName || '',
                  hasCertificationDoc: !!certificationDoc?.data?.documentPath,
                  isValid: doc.data?.valid,
                  isValidYN: doc.data?.validYN,
                  certificationId: doc.data?.g04docuGCertificationId
                };
              })
            ) || []
          ) || [];
        }

        return {
          label: child.label,
          documentCells,
          productNames,
          etcDocs
        };
      }) || [];
      // 회사가 없는 경우 건너뛰기
      if (companies.length === 0) {
        return [];
      }
      // 회사별로만 구분/회사명 머지
      return companies.flatMap((company, companyIndex) => {
        const productCount = company.productNames.length || 1;
        // 제품이 없는 경우 하나의 행만 반환
        if (productCount === 1 && company.productNames.length === 0) {
          return [{
            id: `${item.id}-${companyIndex}`,
            label: rowData?.label,
            company: company.label.split(':')[0],
            documentCells: company.documentCells,
            productName: '',
            labelRowspan: 1,
            companyRowspan: 1,
            etcDocs: company.etcDocs
          }];
        }
        // 각 제품마다 별도의 행 생성, 첫 번째 행에만 rowspan
        return company.productNames.map((productName, productIndex) => ({
          id: `${item.id}-${companyIndex}-${productIndex}`,
          label: rowData?.label,
          company: company.label.split(':')[0],
          documentCells: company.documentCells,
          productName,
          labelRowspan: productIndex === 0 ? productCount : 0,
          companyRowspan: productIndex === 0 ? productCount : 0,
          etcDocs: company.etcDocs
        }));
      });
    });

  console.log('rows', rows);
  console.log('selected', selected);
  return { headers, rows };
};

const tooltipTop = {
  "& .MuiTooltip-tooltip": {
    borderRadius: "0px",
  }
};

const defaultValues ={
  fileName: "",
  comments: "",

  // 날인문구
  // supplierLabel: "제공사",
  // supplier: "",
  recipientLabel: "제출처",
  recipient: "",
  siteLabel: "현장명",
  site: "",
  phrase: "",
}

const GProjectG04ContentView = ({
  gsupplyConfirm,
  crudMode,
  setCrudMode,
  itemsWithDocus,
  setItemsWithDocus,
  itemsWithoutDocus,
  setItemsWithoutDocus,
  selected: selectedProps = [],
  setSelected,
  onSelect: onSelectProps = () => {},
  disableMultiParentSelection = true,
  handleClickViewEachDoc,
  handleClickViewSummary,
  handleClickAddSubstituteTestDoc,
  handleClickViewMaterialApproval,
  makeMaterialApproval,
  gclient,
  gproject,
  from,
  showMaterialApproval,
  setParentShow,
  reGenerate,
  closedGClientList,
  setOpenRequest,
  refreshClosedGClients,
  documentViewerDrawerOpen,
  closeDocumentViewer,
}) => {
  // 선택된 문서 정보 상태 추가
  const [selectedDocument, setSelectedDocument] = useState(null);
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});
  
  // 기존 문서관련 발급 옵션 유지
  const [docAttachedNValidDate, setDocAttachedNValidDate] = useState(true);
  const [docValidDate, setDocValidDate] = useState(false);
  const [docInvalidDate, setDocInvalidDate] = useState(false);
  const [docAttached, setDocAttached] = useState(false);
  const [docUnattached, setDocUnattached] = useState(false);

  // 단순화한 문서관련 발급 옵션
  const [includeExpiredDocs, setIncludeExpiredDocs] = useState(false);
  const [includeUnattachedDocs, setIncludeUnattachedDocs] = useState(false);
  const [includeGTestComparisons, setIncludeGTestComparisons] = useState(true);

  const [myCertified, setMyCertified] = useState(false);
  const [signOption, setSignOption] = useState("CERTIFIED_TRUE_COPY_AND_SIGN");

  const [URLThumbnail, setURLThumbnail] = useState("");
  const [emptyRecipient, setEmptyRecipient] = useState(false);
  const [emptySite, setEmptySite] = useState(false);

  const [showAll, setShowAll] = useState(true);
  const [showOnlyMissingDocs, setShowOnlyMissingDocs] = useState(false);
  const [showOnlyExpiredDocs, setShowOnlyExpiredDocs] = useState(false);
  const [filteredItems, setFilteredItems] = useState(itemsWithDocus);

  const [viewMode, setViewMode] = useState('tree'); // 'tree' 또는 'table'
  const [testReportManagerOpen, setTestReportManagerOpen] = useState(false);

  const documentTableData = React.useMemo(() => {
    console.log("selectedProps changed:", selectedProps);
    console.log('itemsWithDocus', itemsWithDocus)
    const materialApprovalItem = itemsWithDocus.find(item => item.id === "GMATERIAL_APPROVAL");
    if (pathname === "/g04docuMaterialApproval" && materialApprovalItem?.data?.tableDocumentData) {
      return materialApprovalItem.data.tableDocumentData;
    }
    
    // selectedProps에 있는 ID를 가진 노드들을 필터링
    const filterSelectedNodes = (nodes) => {
      if (!nodes || !Array.isArray(nodes)) return [];
      
      return nodes
        .filter(node => !selectedProps.includes(node.id))  // 먼저 selectedProps에 있는 노드 제외
        .map(node => {
          // children이 있으면 재귀적으로 필터링
          if (node.children && Array.isArray(node.children)) {
            return {
              ...node,
              children: filterSelectedNodes(node.children)
            };
          }
          // children이 없는 경우
          return { ...node };
        });
    };

    // 속도 측정
    // console.time('cloneDeep');
    const cloneDeepResult = cloneDeep(itemsWithDocus);
    // console.timeEnd('cloneDeep');

    // console.time('JSON');
    // const jsonResult = JSON.parse(JSON.stringify(itemsWithDocus));
    // console.timeEnd('JSON');

    const filteredItemsWithDocus = filterSelectedNodes(cloneDeepResult);
    // console.log('filteredItemsWithDocus', filteredItemsWithDocus);
    return prepareDocumentTableData(filteredItemsWithDocus, gproject, selectedProps);
  }, [itemsWithDocus, gproject, selectedProps]);

  const materialTableData = React.useMemo(() => {
    const materialApprovalItem = itemsWithDocus.find(item => item.id === "GMATERIAL_APPROVAL");
    if (materialApprovalItem?.data?.tableMaterialData) {
      return materialApprovalItem.data.tableMaterialData;
    }
  
    return prepareMaterialTableData(gproject);
  }, [itemsWithDocus, gproject]);
  
  console.log('materialTableData:', materialTableData);
  console.log('documentTableData:', documentTableData);

  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode);
    }
  };

  // 단순화된 UI의 체크박스 핸들러
  const handleIncludeExpiredDocs = (e, checked) => {
    setIncludeExpiredDocs(checked);
    
    // 기존 state 동기화
    setDocAttachedNValidDate(!checked);
    setDocValidDate(!checked);
    setDocInvalidDate(checked);
    if (!docAttached && !docUnattached) {
      setDocAttached(true);
    }
  };

  const handleIncludeUnattachedDocs = (e, checked) => {
    setIncludeUnattachedDocs(checked);
    
    // 기존 state 동기화
    setDocAttachedNValidDate(!checked);
    setDocUnattached(checked);
    setDocAttached(!checked);
    if (!docValidDate && !docInvalidDate) {
      setDocValidDate(true);
    }
  };

  const handleIncludeGTestComparisons = (e, checked) => {
    setIncludeGTestComparisons(checked);
  };

  const handleAllToggle = () => {
    setShowAll(true);
    setShowOnlyMissingDocs(false);
    setShowOnlyExpiredDocs(false);
    setFilteredItems(itemsWithDocus);
  };
  
  const handleMissingDocsToggle = () => {
    setShowAll(false);
    setShowOnlyMissingDocs(prev => !prev);
    setShowOnlyExpiredDocs(false);
    filterItems();
  };
  
  const handleExpiredDocsToggle = () => {
    setShowAll(false);
    setShowOnlyMissingDocs(false);
    setShowOnlyExpiredDocs(prev => !prev);
    filterItems();
  };

  const filterMissingDocs = (nodes) => {
    return nodes.filter(node => {
      if (node.children && node.children.length > 0) {
        node.children = filterMissingDocs(node.children);
        return node.children.length > 0;
      }
      return node.type?.substring(0, 3) === 'DOC' && 
        !(node.data?.documentPath || node.data?.performanceData?.performanceDocumentPath);
    });
  };

  const filterExpiredDocs = (nodes) => {
    return nodes.filter(node => {
      if (node.children && node.children.length > 0) {
        node.children = filterExpiredDocs(node.children);
        return node.children.length > 0;
      }
      if (node.type?.substring(0, 3) !== 'DOC' || !node.data?.documentPath) {
        return false;
      }
      // 성적서는 로그인 업체의 성적서만 만료를 본다.
      if (node.type === 'DOCTEST' && node.data?.gclientId !== node.data?.gclient?.id) {
        return false;
      }
      if (node.data?.validYN === true) {
        return false;
      }
      const datePassed = !!node.data?.endDate && node.data?.valid === false;
      const mandatoryUnset = (node.type === 'DOCTEST' || node.type === 'DOCCERTIFICATION') && !node.data?.endDate;
      return datePassed || mandatoryUnset;
    });
  };
  
  const deepClone = (obj) => {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
  
    if (Array.isArray(obj)) {
      return obj.map(deepClone);
    }
  
    const clonedObj = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = deepClone(obj[key]);
      }
    }
    return clonedObj;
  };

  const filterItems = () => {
    if (!itemsWithDocus) return; // itemsWithDocus가 undefined일 경우 함수 종료
  
    // console.time('JSON');
    // let newFilteredItems = JSON.parse(JSON.stringify(itemsWithDocus)); // 깊은 복사
    // console.timeEnd('JSON');

    // console.time('deepClone');
    let newFilteredItems = deepClone(itemsWithDocus);
    // console.timeEnd('deepClone');
  
    if (showOnlyMissingDocs) {
      newFilteredItems = filterMissingDocs(newFilteredItems);
    }
  
    if (showOnlyExpiredDocs) {
      newFilteredItems = filterExpiredDocs(newFilteredItems);
    }
  
    console.log({ itemsWithDocus, newFilteredItems })
    setFilteredItems(newFilteredItems);
  };

  useEffect(() => {
    if (itemsWithDocus) { // itemsWithDocus가 존재할 때만 filterItems 실행
      filterItems();
    }
  }, [showOnlyMissingDocs, showOnlyExpiredDocs, itemsWithDocus]);

  const { handleSubmit, reset, control, setValue } = useForm({ defaultValues: defaultValues });

  const dispatch = useDispatch();

  const sessionUser = useSelector(state => state.session.sessionUser);

  const downloadFile = (documentPath) => gclientActions.downloadDirect(documentPath)

  // const handleToggle = (event, nodeIds) => {
  //   setExpanded(nodeIds);
  // };

  const handleSelect = (value) => {
    onSelectProps((prevSelected) => {
      // if (
      //   prevSelected.some(
      //     (prevSelect) =>
      //       prevSelect.startsWith('main.') && prevSelect !== value,
      //   )
      // ) {
      //   return prevSelected;
      // }

      if (prevSelected.includes(value)) {
        return prevSelected.filter((prevSelect) => prevSelect !== value);
      }

      return [...prevSelected, value];
    });
  };

  useEffect(
    async () => {
      if (sessionUser) {
        const { signDocumentPath } = sessionUser;
        if (signDocumentPath) {
          const res = await downloadFile(signDocumentPath);
          const blob = await res.blob(); // res.blob()는 비동기 함수이므로 await 필요
          const url = URL.createObjectURL(blob);
          setURLThumbnail(url);
        }

        if (sessionUser["phrases"]) {
          const { supplierLabel, supplier, phrase } = sessionUser["phrases"];
          setValue("supplierLabel", supplierLabel);
          setValue("supplier", supplier);
          setValue("phrase", phrase);
        }
      }
    }, [open]
  )
  // useEffect(() => {
  //   setSelected(selectedProps);
  // }, [selectedProps]);

  // const handleClickCheckedDoc = async () => {
  //   // console.log(itemsWithDocus)
  //   // const data = [];
  //   // JSON.stringify(itemsWithDocus, function(key, value) {
  //   //   // console.log({ key, value });
  //   //   if (key === 'documentPath' && value !== "") {
  //   //     data.push({ key, value });
  //   //   }

  //   //   return value; // return 하지 않으면 탐색 안됨
  //   // });

  //   // console.log(data)
  //   // handleSelect("SUPPLIER");

  //   // console.log(selectedProps);
  //   // console.log(itemsWithDocus)
  //   const documentAttached = [];
  //   const documentToGenerate = [];
    
  //   itemsWithDocus.forEach(root => { // root : 공급업체(SUPPLIER), 원자재(RAW_MATERIAL), 가공(PROCESS), 가공부자재(SUB_MATERIAL_PROCESS), 시공부자재(SUB_MATERIAL_BUILD)
  //     if (selectedProps.some(selectedProp => selectedProp === root.id)) return;

  //     const gclients = root.children;
  //     if(gclients && Array.isArray(gclients)) { // root.children : 업체목록
  //       gclients.forEach(gclient => {
  //         if (selectedProps.some(selectedProp => selectedProp === gclient.id)) return;
          
  //         documentToGenerate.push({
  //           name: gclient.label,
  //           // parent: { name: root.label },
  //           main: root.label,
  //           type: "MAIN",
  //         }); // 1. 메인분류(공급업체,원자재 등)와 업체명

  //         const categories = gclient.children;
  //         if (categories && Array.isArray(categories)) { // categories : 일반문서(GENERALS), 인증서(CERTIFICATIONS), 성적서(TESTS), 기타(ETCS)
  //           categories.forEach(category => {
  //             if (selectedProps.some(selectedProp => selectedProp === category.id)) return;

  //             const docs = category.children // docs : 실제 문서들. 성적서의 경우 ITEM임(한단계(children) 더 있음)
  //             if (docs && Array.isArray(docs)) {
                
  //               documentToGenerate.push({
  //                 name: category.label,
  //                 list: docs.length > 0 ? docs.map(doc => ({ name: doc.label, list: doc.children?.map(item => ({ name: item.label })) })) : [],
  //                 type: "CONTENTS",
  //               }); // 2. 문서종류와 하위목차

  //               docs.forEach(doc => {
  //                 if (selectedProps.some(selectedProp => selectedProp === doc.id)) return;

  //                 console.log(doc)
  //                 const { type, label } = doc;
  //                 if (type === 'ITEM') {
  //                   const tests = doc.children;
  //                   if (tests && Array.isArray(tests)) {
  //                     tests.forEach(test => {
  //                       if (test && test.data?.documentPath) {
  //                         // console.log(test)
  //                         !selectedProps.some(selectedProp => selectedProp === test.id) && documentAttached.push(test);
  //                         !selectedProps.some(selectedProp => selectedProp === test.id) && documentToGenerate.push({
  //                           header: { right: `${label} - ${test.label}`, left : gclient.label.split(":")[0] },
  //                           content: test.data.documentPath,
  //                           type: "DOC",
  //                         }); // 3. 실제문서 : 성적서
  //                       }
  //                     })
  //                   }
                    
  //                 } else {
  //                   if (doc && doc.data?.documentPath) {
  //                     // console.log(doc)
  //                     !selectedProps.some(selectedProp => selectedProp === doc.id) && documentAttached.push(doc);
  //                     !selectedProps.some(selectedProp => selectedProp === doc.id) && documentToGenerate.push({
  //                       header: { right: doc.label, left : gclient.label.split(":")[0] },
  //                       content: doc.data.documentPath,
  //                       type: "DOC",
  //                     }); // 3. 실제문서 : 성적서 이외의 문서
  //                   }
  //                 }
  //               })
  //             }
  //           })
  //         }
  //       })
  //     }
  //   })

  //   console.log(documentAttached);
  //   console.log(documentToGenerate);

  //   const g04docuMaterialApproval = await makeMaterialApproval({
  //     gclientId: gclient.id,
  //     gclient,
  //     gprojectId: gproject.id,
  //     gproject: { // TODO : 불필요한 데이터는 빼고 필요한 데이터만 추출하는 세련된 방법 필요 (객체의 함수로 만들고 scope를 정하여 해당 정보만을 리턴하도록 하는 등...)
  //       id: gproject.id,
  //       site: gproject.site,
  //       owner: gproject.owner,
  //       doneYN: gproject.doneYN,
  //       startDate: gproject.startDate,
  //       endDate: gproject.endDate,
  //       siteAddress: gproject.siteAddress,
  //     },
  //     generatedInformation: itemsWithoutDocus,
  //     generatedInformationWithDocus: itemsWithDocus,
  //     generatedInformationForPdfs: documentToGenerate,
  //     excluded: selectedProps,
  //   });

  //   // setShowPreview(true);
  // }

  // const handleClickCheckedDocInBrowser = () => {
  //   const documentAttached = [];
  //   const documentToGenerate = [];
    
  //   itemsWithDocus.forEach(root => { // root : 공급업체(SUPPLIER), 원자재(RAW_MATERIAL), 가공(PROCESS), 가공부자재(SUB_MATERIAL_PROCESS), 시공부자재(SUB_MATERIAL_BUILD)
  //     if (selectedProps.some(selectedProp => selectedProp === root.id)) return;

  //     const gclients = root.children;
  //     if(gclients && Array.isArray(gclients)) { // root.children : 업체목록
  //       gclients.forEach(gclient => {
  //         if (selectedProps.some(selectedProp => selectedProp === gclient.id)) return;
          
  //         documentToGenerate.push({
  //           name: gclient.label,
  //           // parent: { name: root.label },
  //           main: root.label,
  //           type: "MAIN",
  //         }); // 1. 메인분류(공급업체,원자재 등)와 업체명

  //         const categories = gclient.children;
  //         if (categories && Array.isArray(categories)) { // categories : 일반문서(GENERALS), 인증서(CERTIFICATIONS), 성적서(TESTS), 기타(ETCS)
  //           categories.forEach(category => {
  //             if (selectedProps.some(selectedProp => selectedProp === category.id)) return;

  //             const docs = category.children // docs : 실제 문서들. 성적서의 경우 ITEM임(한단계(children) 더 있음)
  //             if (docs && Array.isArray(docs)) {
                
  //               documentToGenerate.push({
  //                 name: category.label,
  //                 list: docs.length > 0 ? docs.map(doc => ({ name: doc.label, list: doc.children?.map(item => ({ name: item.label })) })) : [],
  //                 type: "CONTENTS",
  //               }); // 2. 문서종류와 하위목차

  //               docs.forEach(doc => {
  //                 if (selectedProps.some(selectedProp => selectedProp === doc.id)) return;

  //                 console.log(doc)
  //                 const { type, label } = doc;
  //                 if (type === 'ITEM') {
  //                   const tests = doc.children;
  //                   if (tests && Array.isArray(tests)) {
  //                     tests.forEach(test => {
  //                       if (test && test.data?.documentPath) {
  //                         // console.log(test)
  //                         !selectedProps.some(selectedProp => selectedProp === test.id) && documentAttached.push(test);
  //                         !selectedProps.some(selectedProp => selectedProp === test.id) && documentToGenerate.push({
  //                           header: { right: `${label} - ${test.label}`, left : gclient.label.split(":")[0] },
  //                           content: test.data.documentPath,
  //                           type: "DOC",
  //                         }); // 3. 실제문서 : 성적서
  //                       }
  //                     })
  //                   }
                    
  //                 } else {
  //                   if (doc && doc.data?.documentPath) {
  //                     // console.log(doc)
  //                     !selectedProps.some(selectedProp => selectedProp === doc.id) && documentAttached.push(doc);
  //                     !selectedProps.some(selectedProp => selectedProp === doc.id) && documentToGenerate.push({
  //                       header: { right: doc.label, left : gclient.label.split(":")[0] },
  //                       content: doc.data.documentPath,
  //                       type: "DOC",
  //                     }); // 3. 실제문서 : 성적서 이외의 문서
  //                   }
  //                 }
  //               })
  //             }
  //           })
  //         }
  //       })
  //     }
  //   })

  //   console.log(documentAttached);
  //   console.log(documentToGenerate);

  //   // // create a document and pipe to a blob
  //   // var doc = new PDFDocument();
  //   // var stream = doc.pipe(blobStream());

  //   // // draw some text
  //   // doc.fontSize(25).text('Here is some vector graphics...', 100, 80);

  //   // // some vector graphics
  //   // doc
  //   //   .save()
  //   //   .moveTo(100, 150)
  //   //   .lineTo(100, 250)
  //   //   .lineTo(200, 250)
  //   //   .fill('#FF3300');

  //   // doc.circle(280, 200, 50).fill('#6600FF');

  //   // // an SVG path
  //   // doc
  //   //   .scale(0.6)
  //   //   .translate(470, 130)
  //   //   .path('M 250,75 L 323,301 131,161 369,161 177,301 z')
  //   //   .fill('red', 'even-odd')
  //   //   .restore();

  //   // // and some justified text wrapped into columns
  //   // doc
  //   //   .text('And here is some wrapped text...', 100, 300)
  //   //   .font('Times-Roman', 13)
  //   //   .moveDown()
  //   //   .text(lorem, {
  //   //     width: 412,
  //   //     align: 'justify',
  //   //     indent: 30,
  //   //     columns: 2,
  //   //     height: 300,
  //   //     ellipsis: true
  //   //   });

  //   // // end and display the document in the iframe to the right
  //   // doc.end();
  //   // stream.on('finish', function() {
  //   //   iframe.src = stream.toBlobURL('application/pdf');
  //   // });
  //   const iframe = document.querySelector("iframe");
  //   // iframe.src = stream.toBlobURL('application/pdf');
  //   // iframe.src = 'http://www.warpcore.co.kr'
  //   iframe.src = 'http://localhost:5002/files/Material Approvals/(주)워프코어(356d05cd-2bf1-46b4-8075-c6a951707bb7)/NEW(ccfdbe72-d918-4132-a884-41b876bc0bc6)/NEW_ma_2023-08-03-183410-660.pdf'
  // }

  const equalsIgnoreOrder = (a, b) => {
    if (a.length !== b.length) return false;
    const uniqueValues = new Set([...a, ...b]);
    for (const v of uniqueValues) {
      const aCount = a.filter(e => e === v).length;
      const bCount = b.filter(e => e === v).length;
      if (aCount !== bCount) return false;
    }
    return true;
  }

  const onSubmit = async ({ fileName, comments, supplierLabel, supplier, recipientLabel, recipient, siteLabel, site, phrase }, e) => {
    setLoading(true);

    const phrases = {
      // supplierLabel,
      // supplier,
      recipientLabel,
      recipient,
      siteLabel,
      site,
      // phrase,
    };

    const generateOptions = {
      // 발급옵션
      docAttachedNValidDate: docAttachedNValidDate ? 'Y' : 'N',
      docValidDate: docValidDate ? 'Y' : 'N',
      docInvalidDate: docInvalidDate ? 'Y' : 'N',
      docAttached: docAttached ? 'Y' : 'N',
      docUnattached: docUnattached ? 'Y' : 'N',
      includeGTestComparisons: includeGTestComparisons ? 'Y' : 'N',
      // 문서처리옵션
      myCertified: myCertified ? 'Y' : 'N',
      sign: signOption,
      phrases,
    };

    const documentIncluded = [];
    const documentToGenerate = [];
    const domesticAuths = [];
    
    itemsWithDocus.forEach(root => { // root : 공급업체(SUPPLIER), 원자재(RAW_MATERIAL), 가공(PROCESS), 가공부자재(SUB_MATERIAL_PROCESS), 시공부자재(SUB_MATERIAL_BUILD)
      if (selectedProps.some(selectedProp => selectedProp === root.id)) return;

      if (root.id === "GMATERIAL_APPROVAL") {
        documentToGenerate.push({
          name: "",
          main: "자재승인서 요약",
          type: "MAIN",
        });

        documentToGenerate.push({
          name: "요약표",
          type: "CONTENTS",
          exist: true,
          valid: true,
          validYN: true,
          list: [{
            name: "자재정보",
            exist: true,
            valid: true,
            validYN: true,
          }, {
            name: "공급업체별 첨부서류",
            exist: true,
            valid: true,
            validYN: true,
          }],
        });

        documentToGenerate.push({
          type: "TABLE_HTML",
          tableHtml: root.data.tableHtmlMaterial,
        });

        documentToGenerate.push({
          type: "TABLE_HTML",
          tableHtml: root.data.tableHtmlDocument,
        });
      }
      // TODO : 여기의 gclients는 GProjectGlasses의 selectedGcomponentItems의 gclient임. 그리고 GProjectGlasses의 selectedGcomponentItems의 gclient는 GClientGComponentItemMaps의 gclient임
      // GClientGComponentItemMaps은 거래선에서 제품 매핑할 때 기록되는데 이후 거래선 정보가 변경될 때 반영되지 못하는 심각한 문제가 발생
      // 갱신된 gclient 정보관리에 대해 어떻게 해야 할지 고민중... DB 필드에 gclient가 있는 부분 전체 점검이 필요하고 gclientId만 저장하고 해당 아이디로 authServer에서 gclients 정보를 가져와 비교해야 할 것으로 보임
      const gclients = root.children;
      if(gclients && Array.isArray(gclients)) { // root.children : 업체목록
        gclients.forEach(gclient => {
          // console.log(gclient)
          // console.log(gclient.data.gclient)
          if (selectedProps.some(selectedProp => selectedProp === gclient.id)) return;
          
          // 국내가공유리제품 사전 인증서는 따로 관리함
          if (gclient.type === "DOMESTIC_AUTH") {
            domesticAuths.push(gclient); // 업체명이었다가 뒤에 국내가공유리제품 사전 인증서 기능이 추가되어 변수명 gclients는 맞지 않지만 그대로 사용함
            return; // continue
          } else if (gclient.type === "GSUPPLY_CONFIRM_SUMMARY" || gclient.type === "GSUPPLY_CONFIRM_DOC") {
            console.log(root)
            console.log(gclient)
            // 납품확인서 관련 데이터 추가
            if (gclient.type === "GSUPPLY_CONFIRM_SUMMARY") {
              // 메인 제목 추가
              documentToGenerate.push({
                main: "납품확인서 제출업체",
                name: gclient.data.gclient.name,
                // phrases: null,
                // sign: null,
                type: "MAIN",
                // 납품확인서용
                docType: 'GSUPPLY_CONFIRM',
              });
              // 납품확인서 목차 추가
              const list = root.children
                .filter(child => !selectedProps.some(selectedProp => selectedProp === child.id))
                .map((child, index) => ({
                  exist: index === 0 ? true : (child.data?.documentPath ? true : false), // 첫번째 항목은 무조건 true
                  name: child.label,
                  opened: child.data?.opened || true,
                  valid: child.data?.valid || true,
                  validYN: child.data?.validYN || true,
                }));
              documentToGenerate.push({
                exist: true,
                list,
                name: "납품확인서",
                type: "CONTENTS",
                valid: true,
                validYN: true,
                // 납품확인서용
                docType: 'GSUPPLY_CONFIRM',
              });
              // 요약표 데이터 추가
              documentToGenerate.push({
                content: null, // 요약 데이터는 서버에서 처리
                exist: true,
                header: { right: "납품확인서 요약표", left: root.label },
                opened: true,
                type: "TABLE_DATA",
                valid: true,
                validYN: true,
                // 납품확인서용
                docType: 'GSUPPLY_CONFIRM',
                tableData: gclient.data?.tableData,
                sign: gclient.data?.gclient?.signDocumentPath,
                phrases: gclient.data?.gclient?.phrases,
              });
            } else if (gclient.type === "GSUPPLY_CONFIRM_DOC") {
              // 개별 납품확인서 문서 추가
              documentToGenerate.push({
                content: gclient.data?.documentPath,
                exist: gclient.data?.documentPath ? true : false,
                header: { right: "납품확인서", left: gclient.label },
                opened: gclient.data?.opened || true,
                type: "DOC",
                valid: gclient.data?.valid || true,
                validYN: gclient.data?.validYN || true,
                // 납품확인서용
                docType: 'GSUPPLY_CONFIRM',
                sign: gclient.data?.gclient?.signDocumentPath,
                phrases: gclient.data?.gclient?.phrases,
              });
            }

            return; // continue
          }

          documentToGenerate.push({
            name: gclient.label,
            // parent: { name: root.label },
            main: root.label,
            type: "MAIN",
            sign: gclient?.data?.gclient?.signDocumentPath,
            phrases: gclient?.data?.gclient?.phrases,
          }); // 1. 메인분류(공급업체,원자재 등)와 업체명

          const categories = gclient.children;
          if (categories && Array.isArray(categories)) { // categories : 일반문서(GENERALS), 인증서(CERTIFICATIONS), 성적서(TESTS), 기타(ETCS)
            categories.forEach(category => {
              if (selectedProps.some(selectedProp => selectedProp === category.id)) return;
              
              // docs : 실제 문서들. 성적서의 경우 원자재나 가공은 ITEM(한단계(children) 더 있음)이고 시가공부자재는 인증규격(제품그룹)이고 그 아래에 제품(ITEM) 여기에 하나더 하위가 실제 문서임
              const docs = category.children;
              if (docs && Array.isArray(docs) && docs.length > 0) {
                
                // console.log({ name: category.label, docs });
                
                let list = null;
                // let exist = true;
                if (docs.length > 0) {
                  const { type } = docs[0];
                  // console.log(docs)
                  if (type === 'DOCGENERAL' || type === 'DOCCERTIFICATION') {
                    list = docs.filter(doc => !selectedProps.some(selectedProp => (selectedProp === doc.id)))
                               .map(doc => ({ name: doc.label, exist: doc.data?.documentPath ? true : false, valid: doc.data?.valid ? true : false, validYN: doc.data?.validYN, opened: gclient.data.gclient.opened }))
                  } else if (type === 'ITEM') {
                    list = docs.filter(doc => !selectedProps.some(selectedProp => (selectedProp === doc.id)))
                               .map(doc => {
                                  if (doc.children && doc.children.length > 0) {
                                    const filtered = doc.children.filter(item => !selectedProps.some(selectedProp => (selectedProp === item.id)))
                
                                    const itemList = filtered.map(item => {
                                      const subItemList = []
                                      if (item.data.division === 'SUB_MATERIAL_PROCESS' || item.data.division === 'SUB_MATERIAL_BUILD') {
                                        const filteredSubs = item.children.filter(i => !selectedProps.some(selectedProp => (selectedProp === i.id)));
                                        filteredSubs.forEach(subItem => {
                                          const substitute = subItem.data?.substitute === 'Y' ? 'Y' : 'N';
                                          subItemList.push({
                                            name: `${subItem.label}${substitute === 'Y' ? " (*대체성적서)" : ""}`,
                                            exist: subItem.data?.documentPath ? true : false,
                                            valid: subItem.data?.valid ? true : false,
                                            validYN: subItem.data?.validYN,
                                            // substitute,
                                            // substituteInformation: subItem.data?.substituteInformation,
                                          });
                                        });
                                      }
                                      // console.log(item)
                                      // 아래에서 시가공부자재는 item.data가 성적서가 아니고 item.children이 실제 성적서임
                                      if (item.data.division === 'SUB_MATERIAL_PROCESS' || item.data.division === 'SUB_MATERIAL_BUILD') {
                                        let exist;
                                        let valid;
                                        let validYN;
                                        if (item.children && Array.isArray(item.children)) {
                                          item.children.forEach(c => {
                                            exist = exist || (c.data.documentPath ? true : false);
                                            valid = valid || c.data.valid;
                                            validYN = validYN || c.data.validYN;
                                          });
                                        }
                                        // console.log({ exist, valid, validYN })
                                        return {
                                          name: item.label,
                                          exist,
                                          valid,
                                          validYN,
                                          list: subItemList,
                                        }
                                      } else {
                                        const gglassPerformanceYN = item.data?.performanceData?.performanceDocumentPath ? 'Y' : 'N';
                                        return {                                          
                                          name: `${item.label}${!item.data?.documentPath && gglassPerformanceYN === 'Y' ? " (*성능확인서)" : ""}${item.data?.substitute === 'Y' ? " (*대체성적서)" : ""}`,
                                          exist: (item.data?.documentPath || item.data?.performanceData?.performanceDocumentPath) ? true : false, // TODO : 복층유리에서만 필요
                                          // valid: item.data?.performanceData?.performanceDocumentPath ? true : (item.data?.valid ? true : false), // TODO : 복층유리에서만 필요
                                          // valid: item.data?.performanceData?.performanceDocumentPath ? true : (item.data?.valid ? true : false), // TODO : 복층유리에서만 필요
                                          valid: item.data?.documentPath ? (item.data?.valid ? true : false) : (item.data?.performanceData?.performanceDocumentPath && true), // TODO : 복층유리에서만 필요
                                          // validYN: doc.data?.validYN,
                                          validYN: item.data?.validYN,
                                          // list: subItemList.length > 0 ? subItemList : [],
                                          gglassPerformanceYN,
                                          // substitute: item.data?.substitute,
                                          // substituteInformation: item.data?.substituteInformation,
                                        }
                                      }
                                    });
                                    
                                    // console.log(doc)
                                    // console.log(filtered)
                                    let exist;
                                    let valid;
                                    let validYN;
                                    // let gglassPerformanceYN = "";
                                    // 아래에서 시가공부자재는 filtered안의 item.data가 성적서가 아니고 item.children이 실제 성적서임
                                    filtered.forEach(f => {
                                      if (doc.data.itemType === 'SUB_MATERIAL_PROCESS' || doc.data.itemType === 'SUB_MATERIAL_BUILD') {
                                        f.children.forEach(c => {
                                          exist = exist || c.data.documentPath;
                                          valid = valid || c.data.valid;
                                          validYN = validYN || c.data.validYN;
                                        });
                                      } else {
                                        exist = exist || (f.data.documentPath || f.data?.performanceData?.performanceDocumentPath); // TODO : 복층유리에서만 필요
                                        // valid = valid || f.data?.performanceData?.performanceDocumentPath ? true : f.data.valid; // TODO : 복층유리에서만 필요
                                        valid = f.data?.documentPath ? (f.data?.valid ? true : false) : (f.data?.performanceData?.performanceDocumentPath && true); // TODO : 복층유리에서만 필요
                                        validYN = validYN || f.data.validYN;
                                        // gglassPerformanceYN = f.data?.performanceData?.performanceDocumentPath ? 'Y' : 'N';
                                      }
                                    });

                                    return {
                                      name: doc.label,
                                      list: itemList,
                                      exist: exist ? true : false,
                                      valid: valid ? true : false,
                                      validYN: validYN ? true : false,
                                      opened: gclient.data.gclient.opened,
                                    }
                                  } else {
                                    return { name: doc.label, list, exist: false, valid: false, validYN: false }
                                  }
                               });
                  }
                }

                let exist = false;
                let valid = false;
                let validYN = false;
                // console.log(list)
                if (list && Array.isArray(list) && list.length > 0) {
                  list.forEach(L => {
                    if (L.list) {
                      L.list.forEach(l => {
                        exist = exist || l.exist;
                        valid = valid || l.valid;
                        validYN = validYN || l.validYN;
                      });
                    } else {
                      exist = exist || L.exist;
                      valid = valid || L.valid;
                      validYN = validYN || L.validYN;
                    }
                  });

                  exist = exist ? true : false;
                  valid = valid ? true : false;
                  validYN = validYN ? true : false;

                  // const resultsExist = list.filter(item => {
                  //   if (item.list) {
                  //     return (item.list.filter(item1 => item1.exist === true).length > 0 ? true : false)
                  //   }

                  //   return (item.exist === true ? true : false);
                  // })
                  // exist = resultsExist.length > 0 ? true : false;

                  // const resultsValid = list.filter(item => {
                  //   if (item.list) {
                  //     return (item.list.filter(item1 => item1.valid === true).length > 0 ? true : false)
                  //   }

                  //   return (item.valid === true ? true : false);
                  // })
                  // valid = resultsValid.length > 0 ? true : false;

                  // const resultsValidYN = list.filter(item => {
                  //   if (item.list) {
                  //     return (item.list.filter(item1 => item1.validYN === true).length > 0 ? true : false)
                  //   }

                  //   return (item.validYN === true ? true : false);
                  // })
                  // validYN = resultsValidYN.length > 0 ? true : false;
                }

                // console.log({ exist, valid, validYN })
                // console.log({ exist1, valid1, validYN1 })
                const contents = {
                  name: category.label,
                  list,
                  exist,
                  valid,
                  validYN,
                  type: "CONTENTS",
                };

                documentToGenerate.push(contents);

                if (docs.length > 0) {
                  docs.forEach(doc => {
                    if (selectedProps.some(selectedProp => selectedProp === doc.id)) return;
  
                    // console.log(doc)
                    const { type, label } = doc;
                    if (type === 'ITEM') {
                      const tests = doc.children;
                      if (tests && Array.isArray(tests)) {
                        // console.log(tests)
                        tests.forEach(test => {
                          // if (test && test.data?.documentPath) {
                          if (test && test.data) {
                            // console.log(test)
                            !selectedProps.some(selectedProp => selectedProp === test.id) && documentIncluded.push(test);

                            if (test.data.division === 'SUB_MATERIAL_PROCESS' || test.data.division === 'SUB_MATERIAL_BUILD') {
                              const subTests = test.children;
                              // console.log(subTests)
                              if (subTests && Array.isArray(subTests)) {
                                subTests.forEach(subTest => {
                                  const substitute = subTest.data?.substitute === 'Y' ? 'Y' : 'N';
                                  if (!selectedProps.some(selectedProp => selectedProp === subTest.id)) {
                                    documentIncluded.push(subTest);
                                    documentToGenerate.push({
                                      header: { right: `${test.label} - ${subTest.label}${substitute === 'Y' ? " (*대체성적서)" : ""}`, left : gclient.label.split(":")[0] },
                                      content: subTest.data.documentPath,
                                      /**
                                       * TODO : 시험성과대비표가 있는 경우 => documentToGenerated에 추가로 push하지 않고 아래와 같이 기존 성적서에 contentGTestComparison만 추가
                                       * 시험성과대비표는 추후 최상위 계층의 요약으로 이동할 예정이며, 현재로선 자재승인서 작성서 서버에서 성적서 다음에 출력하도록 하고 있음
                                       */
                                      contentGTestComparison: subTest.data.gtestComparisonDocumentPath,
                                      type: "DOC",
                                      exist: subTest.data?.documentPath ? true : false,
                                      valid: subTest.data?.valid ? true : false,
                                      validYN: subTest.data?.validYN ? true : false,
                                      opened: gclient.data.gclient.opened,
                                      // substitute,
                                      // substituteInformation: subTest.data?.substituteInformation,
                                    }); // 3. 실제문서 : 성적서
                                  }
                                })
                              }
                            } else {
                              const gglassPerformanceYN = test.data?.performanceData?.performanceDocumentPath ? 'Y' : 'N';
                              const substitute = test.data?.substitute === 'Y' ? 'Y' : 'N';
                              const generateObj = {
                                header: { right: `${label} - ${test.label}${!test.data.documentPath && gglassPerformanceYN === 'Y' ? " (*성능확인서)" : ""}${substitute === 'Y' ? " (*대체성적서)" : ""}`, left : gclient.label.split(":")[0] },
                                content: test.data.documentPath || test.data?.performanceData?.performanceDocumentPath, // TODO : 복층유리에서만 필요
                                /**
                                 * TODO : 시험성과대비표가 있는 경우 => documentToGenerated에 추가로 push하지 않고 아래와 같이 기존 성적서에 contentGTestComparison만 추가
                                 * 시험성과대비표는 추후 최상위 계층의 요약으로 이동할 예정이며, 현재로선 자재승인서 작성서 서버에서 성적서 다음에 출력하도록 하고 있음
                                 */
                                contentGTestComparison: test.data.gtestComparisonDocumentPath,
                                type: "DOC",
                                exist: (test.data?.documentPath || test.data?.performanceData?.performanceDocumentPath) ? true : false, // TODO : 복층유리에서만 필요
                                // valid: test.data?.performanceData?.performanceDocumentPath ? true : (test.data?.valid ? true : false), // TODO : 복층유리에서만 필요
                                valid: test.data?.documentPath ? (test.data?.valid ? true : false) : (test.data?.performanceData?.performanceDocumentPath && true), // TODO : 복층유리에서만 필요
                                validYN: test.data?.validYN ? true : false,
                                opened: gclient.data.gclient.opened,
                                gglassPerformanceYN,
                                // substitute,
                                // substituteInformation: test.data?.substituteInformation,
                              };

                              !selectedProps.some(selectedProp => selectedProp === test.id) && documentToGenerate.push(generateObj); // 3. 실제문서 : 성적서
                            }
                          }
                        })
                      }
                      
                    } else {
                      // if (doc && doc.data?.documentPath) {
                      if (doc && doc.data) {
                        if (!selectedProps.some(selectedProp => selectedProp === doc.id)) {
                          documentIncluded.push(doc);
                          documentToGenerate.push({
                            header: { right: doc.label, left : gclient.label.split(":")[0] },
                            content: doc.data.documentPath,
                            type: "DOC",
                            exist: doc.data?.documentPath ? true : false,
                            valid: doc.data?.valid ? true : false,
                            validYN: doc.data?.validYN ? true : false,
                            opened: gclient.data.gclient.opened,
                          }); // 3. 실제문서 : 성적서 이외의 문서
                        }
                      }
                    }
                  })
                } else {
                  // !selectedProps.some(selectedProp => selectedProp === doc.id) && documentIncluded.push(doc);
                  // !selectedProps.some(selectedProp => selectedProp === doc.id) && 
                  documentToGenerate.push({
                    header: { right: category.label, left : gclient.label.split(":")[0] },
                    content: null,
                    type: "DOC",
                    exist: false,
                    valid: false,
                    validYN: false,
                  }); // 문서가 없는 경우 더미문서 추가
                }
              } else if (category.label !== '기타') {
                // 기타 카테고리가 아니고 문서가 없는 경우에만 더미 문서 추가
                documentToGenerate.push({
                  header: { right: category.label, left : gclient.label.split(":")[0] },
                  content: null,
                  type: "DOC",
                  exist: false,
                  valid: false,
                  validYN: false,
                });
              }
            })
          }
        })
      }
    })

    console.log(itemsWithDocus);
    console.log(documentIncluded);
    console.log("첨부되지 않은 문서 목록")
    console.log(documentIncluded.filter(item => item.data.documentPath === null)); // 첨부되지 않은 문서
    console.log("유효기간이 지난 문서 목록")
    console.log(documentIncluded.filter(item => item.data.documentPath !== null && item.data.valid !== true && item.data.validYN !== true)); // 유효기간이 지난 문서
    console.log(documentToGenerate);
    console.log(documentToGenerate.filter(item => item.type === 'CONTENTS'))
    console.log(generateOptions);
    console.log(domesticAuths);

    // TODO : 테스트용으로 주석 풀었음
    // setLoading(false);
    // return;

    try {
      // gclient는 sessionUser임
      const g04docuMaterialApproval = await makeMaterialApproval({
        docType: gsupplyConfirm ? "GSUPPLY_CONFIRM" : "MATERIAL_APPROVAL", // 자재승인서/납품확인서 구분
        gclientId: gclient.id,
        gclient,
        gprojectId: gproject.id,
        gproject: { // TODO : 불필요한 데이터는 빼고 필요한 데이터만 추출하는 세련된 방법 필요 (객체의 함수로 만들고 scope를 정하여 해당 정보만을 리턴하도록 하는 등...)
          id: gproject.id,
          site: gproject.site,
          owner: gproject.owner,
          doneYN: gproject.doneYN,
          startDate: gproject.startDate,
          endDate: gproject.endDate,
          siteAddress: gproject.siteAddress,
        },
        generatedInformation: itemsWithoutDocus,
        generatedInformationWithDocus: itemsWithDocus,
        generatedInformationForPdfs: documentToGenerate,
        excluded: selectedProps,
        fileName,
        comments,
        generateOptions,
        domesticAuths,
      });

      console.log(g04docuMaterialApproval);
      const { results } = g04docuMaterialApproval;
      if (results && results.status === 'ERROR' && results.details[0] === 'Duplicated file name') {
        setAlertInfo({
          titleAlert: "안내",
          messageAlert: "같은 파일이 존재합니다. 다른 파일 이름을 사용해주세요.",
          open: true,
        });

        // setLoading(false);
        return;
      }
      
      setTimeout(() => {
        setLoading(false);
        setOpen(false);
        
        // 서류보관함 열기
        setParentShow(false); // 현재 다이얼로그를 숨기고 Drawer 열어야 함. 그래서 toggleDrawer 내부를 보면 닫힐 때 다시 다이얼로그를 보이게 하는 부분이 있음
        // toggleDrawer("G04DOCU_MATERIAL_APPROVAL", true)(e);
        showMaterialApproval({ g04docuMaterialApproval });
      }, 100);
    } catch (e) {
      console.log(e);
      // setAlertInfo({
      //   titleAlert: "오류",
      //   messageAlert: `자재승인서류 작성 중 오류가 발생하였습니다. 관리자에게 문의해주세요.`,
      //   open: true,
      // });
      dispatch(errorActions.occurError({ response: e.response, serverResponse: e.serverResponse })); // 오류 처리 방식 4
      setTimeout(() => setLoading(false), 2000);
    }
  }
  
  const handleChangeSignOption = (e) => {
    const { value } = e.target;
    setSignOption(value);

    if (value === 'NONE') {
      setMyCertified(false);
    }
  }

  const initDialog = () => {
    for (const [item, value] of Object.entries(defaultValues)) {
      setValue(item, value);
    }

    // 그 외 초기화
    setDocAttachedNValidDate(true);
    setDocValidDate(false);
    setDocInvalidDate(false);
    setDocAttached(false);
    setDocUnattached(false);

    setSignOption("CERTIFIED_TRUE_COPY_AND_SIGN");

    setEmptyRecipient(false);
    setEmptySite(false);
  }

  const handleDialogClose = () => {
    setOpen(false);
    setLoading(false);
    setCrudMode('');

    initDialog();
  }

  const handleChangeDocAttachedNValidDate = (e, checked) => {
    console.log(checked)
    setDocAttachedNValidDate(checked);

    if (checked) {
      setDocValidDate(false);
      setDocInvalidDate(false);
      setDocAttached(false);
      setDocUnattached(false);
    } else {
      setDocValidDate(true);
      setDocUnattached(true);
    }
  }

  const handleChangeDocValidDate = (e, checked) => {
    // console.log(checked)
    setDocValidDate(checked);
    
    setDocInvalidDate(!checked);
    setDocAttachedNValidDate(false);

    if(!docAttached && !docUnattached) {
      setDocAttached(true);
    }
  }

  const handleChangeDocInvalidDate = (e, checked) => {
    // console.log(checked)
    setDocInvalidDate(checked);
    
    setDocValidDate(!checked);
    setDocAttachedNValidDate(false);

    if(!docAttached && !docUnattached) {
      setDocAttached(true);
    }
  }

  const handleChangeDocAttached = (e, checked) => {
    // console.log(checked)
    setDocAttached(checked);

    setDocUnattached(false);
    setDocAttachedNValidDate(false);

    if(!docValidDate && !docInvalidDate) {
      setDocValidDate(true);
    }
  }

  const handleChangeDocUnattached = (e, checked) => {
    // console.log(checked)
    setDocUnattached(checked);

    setDocAttached(false);
    setDocAttachedNValidDate(false);

    if(!docValidDate && !docInvalidDate) {
      setDocValidDate(true);
    }
  }

  const handleChangeMyCertified = (e, checked) => {
    setMyCertified(checked);
  }

  const handleClickGenerate = () => {
    if (documentViewerDrawerOpen) {
      closeDocumentViewer();
    }

    // console.log(sessionUser)
    if (sessionUser) {
      // if (sessionUser["phrases"]) {
      //   const { supplierLabel, supplier, phrase } = sessionUser["phrases"];
      //   setValue("supplierLabel", supplierLabel);
      //   setValue("supplier", supplier);
      //   setValue("phrase", phrase);
      // }
      setValue("supplierLabel", "제공사");
      setValue("supplier", "해당 문서의 제공사가 표시됩니다.");
      setValue("recipient", gproject.constructionCompanyName);
      setValue("site", gproject.site);
      setValue("phrase", "해당 문서의 제공사의 안내문구가 표시됩니다.");
    }

    setOpen(true);
  }

  // const handleChangeRecipient = (e) => {
  //   const { value } = e.target;
  //   // console.log(value)
  //   if (value) {
  //     setEmptyRecipient(false);
  //   } else {
  //     setEmptyRecipient(true);
  //   }

  //   setValue("recipient", value);
  // }

  const handleChangeSite = (e) => {
    const { value } = e.target;
    // console.log(value)
    if (value) {
      setEmptySite(false);
    } else {
      setEmptySite(true);
    }

    setValue("site", value);
  }

  const [materialApprovalDialogOpen, setMaterialApprovalDialogOpen] = useState(false);

  const handleClickInfoMateialApprovalSummary = () => {
    if (pathname === "/g04docuGenerateFile") {
      alert("생성버튼을 누르고 요약정보 보기를 클릭하시면 확인하실 수 있습니다.")
    } else {
      setMaterialApprovalDialogOpen(true);
    }
  };

  const handleClickViewMateialApprovalSummary = () => {
    // console.log(itemsWithDocus)
    setMaterialApprovalDialogOpen(true);
    
    // // 미리보기 창 열기
    // const previewWindowMaterial = window.open('', '_blank');
    // previewWindowMaterial.document.write(tableHtmlMaterial);
    // previewWindowMaterial.document.close();

    // const previewWindowDocument = window.open('', '_blank');
    // previewWindowDocument.document.write(tableHtmlDocument);
    // previewWindowDocument.document.close();
  };
  
  const [tableHtmlMaterial, setTableHtmlMaterial] = useState('');
  const [tableHtmlDocument, setTableHtmlDocument] = useState('');

  const formatHtml = (html) => {
    // 개발 환경에서만 HTML 포맷팅 적용
    if (process.env.NODE_ENV === 'development') {
      const formattedHtml = html
        .replace(/></g, '>\n<')  // 태그 사이에 줄바꿈 추가
        .replace(/\n\s*\n/g, '\n')  // 빈 줄 제거
        .split('\n')
        .map(line => {
          // 닫는 태그는 들여쓰기 감소
          if (line.match(/^<\//)) {
            return line;
          }
          // 여는 태그는 들여쓰기 증가
          if (line.match(/^<[^/]/)) {
            return '  ' + line;
          }
          return line;
        })
        .join('\n');
      return formattedHtml;
    }
    return html;
  };

  // materialTableData나 documentTableData가 변경될 때만 HTML 생성
  useEffect(() => {
    if (materialTableData && documentTableData) {
      const [newTableHtmlMaterial, newTableHtmlDocument] = generateTableHtml();
      
      setTableHtmlMaterial(newTableHtmlMaterial);
      setTableHtmlDocument(newTableHtmlDocument);
    }
  }, [materialTableData, documentTableData]);

  // tableHtmlMaterial, tableHtmlDocument가 변경될 때만 items 업데이트
  useEffect(() => {
    if (tableHtmlMaterial && tableHtmlDocument) {
      if (setItemsWithDocus) {
        setItemsWithDocus(itemsWithDocus.map(item => {
          if (item.id === 'GMATERIAL_APPROVAL') {
            return {
              ...item,
              data: {
                ...item.data,
                tableHtmlMaterial: tableHtmlMaterial,
                tableHtmlDocument: tableHtmlDocument,
                tableMaterialData: materialTableData,
                tableDocumentData: documentTableData,
              },
            }
          }
          return item;
        }));
      }

      if (setItemsWithoutDocus) {
        setItemsWithoutDocus(itemsWithoutDocus.map(item => {
          if (item.id === 'GMATERIAL_APPROVAL') {
            return {
              ...item,
              data: {
                ...item.data,
                tableHtmlMaterial: tableHtmlMaterial,
                tableHtmlDocument: tableHtmlDocument,
                tableMaterialData: materialTableData,
                tableDocumentData: documentTableData,
              },
            }
          }
          return item;
        }));
      }
    }
  }, [tableHtmlMaterial, tableHtmlDocument]);

  const replaceNewlineWithBr = (text) => {
    return text ? text.replace(/\n/g, '<br/>') : text;
  };

  /**
   * TODO : 구분이 페이지 중간에 잘리면 시작부분을 다음 페이지로 넘기고 헤더부터 출력하는데, 이 논리는 전 페이지의 여백이 많이 남게 되는 경우가 있음
   * 구분이 아닌 업체명을 기준으로 페이지 넘기고 헤더부터 출력하는 방식으로 변경해야 함.
   * @returns 
   */
  const generateTableHtml = () => {
    // 자재 테이블 HTML 생성
    const materialTableHtml = `
      <div class="page-break" style="page-break-before: always;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div style="font-size: 1.5rem; font-weight: bold;">1. 자재정보</div>
        </div>
        ${(() => {
          const ROWS_PER_PAGE = 20; // A4 가로 기준 한 페이지당 표시할 행 수
          const pages = [];
          let currentPage = [];
          let currentRowCount = 0;
          let currentLabel = null;
          let remainingRows = [];

          // materialTableData.rows를 평탄화하여 remainingRows 생성
          materialTableData.rows.forEach(row => {
            if (row.items) {
              if (row.type === 'RAW_MATERIAL') {
                const groupedItems = row.items.reduce((acc, item) => {
                  const key = `${item.no}-${item.product1}`;
                  if (!acc[key]) {
                    acc[key] = {
                      items: [item],
                      no: item.no,
                      product1: item.product1,
                      processing: { ...item.processing },
                      division1: row.division1
                    };
                  } else {
                    acc[key].items.push(item);
                    if (item.processing.LAMINATED) {
                      acc[key].processing.LAMINATED = item.processing.LAMINATED;
                    }
                    if (item.processing.INSULATED_GLASS_UNIT) {
                      acc[key].processing.INSULATED_GLASS_UNIT = item.processing.INSULATED_GLASS_UNIT;
                    }
                  }
                  return acc;
                }, {});

                Object.values(groupedItems).forEach(group => {
                  group.items.forEach(item => {
                    remainingRows.push({
                      ...item,
                      group,
                      label: row.division1
                    });
                  });
                });
              } else {
                row.items.forEach(item => {
                  remainingRows.push({
                    ...item,
                    label: row.division1
                  });
                });
              }
            }
          });

          // 페이지 단위로 데이터 분할 (구분 고려)
          while (remainingRows.length > 0) {
            const row = remainingRows[0];
            const isNewLabel = row.label !== currentLabel;
            
            // 현재 페이지가 가득 찬 경우에만 새 페이지 시작
            if (currentRowCount >= ROWS_PER_PAGE) {
              pages.push(currentPage);
              currentPage = [row];
              currentRowCount = 1;
              remainingRows.shift();
              currentLabel = row.label;
            } else {
              // 현재 페이지에 공간이 있으면 계속 채우기
              currentPage.push(row);
              currentRowCount++;
              remainingRows.shift();
              if (isNewLabel) {
                currentLabel = row.label;
              }
            }
          }

          // 마지막 페이지 추가
          if (currentPage.length > 0) {
            pages.push(currentPage);
          }

          // 각 페이지별 테이블 HTML 생성
          return pages.map((pageRows, pageIndex) => `
            ${pageIndex > 0 ? '<div style="page-break-before: always;"></div>' : ''}
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
              <thead>
                <tr>
                  ${materialTableData.headers.map(header => `
                    <th colspan="${header.colspan || 1}" rowspan="${header.rowspan || 1}" 
                        style="font-weight: bold; text-align: center; padding: 4px 8px;">
                      ${header.label}
                    </th>
                  `).join('')}
                </tr>
                <tr>
                  ${materialTableData.headers.map(header => 
                    header.subHeaders?.map(subHeader => `
                      <th style="font-weight: bold; text-align: center; width: ${subHeader.htmlWidth}; padding: 4px 8px;">
                        ${subHeader.label}
                      </th>
                    `).join('') || ''
                  ).join('')}
                </tr>
              </thead>
              <tbody>
                ${pageRows.map((row, index) => {
                  if (row.group) {
                    const group = row.group;
                    return `
                      <tr>
                        ${index === 0 || pageRows[index - 1].label !== row.label ? `
                          <td rowspan="${pageRows.filter(r => r.label === row.label).length}" colspan="2" style="padding: 4px 8px;">${row.label}</td>
                        ` : ''}
                        ${index === 0 || pageRows[index - 1].group?.product1 !== group.product1 ? `
                          <td rowspan="${pageRows.filter(r => r.group?.product1 === group.product1).length}" style="padding: 4px 8px;">${group.product1.replaceAll("|", " ").replaceAll("+", " + ")}</td>
                        ` : ''}
                        <td style="text-align: center; padding: 4px 8px;">
                          ${row.product2.split('\n').map((line, index) => 
                            index === 1 ? 
                              `<div style="color: #1976d2; padding: 4px 8px; border-radius: 4px; display: inline-block;">${line}</div>` :
                              `${line.replace(/\(.*?\)/, "")}${index === 0 ? '<br/>' : ''}`
                          ).join('')}
                        </td>
                        <td style="text-align: center; padding: 4px 8px;">
                          ${row.processing.HEAT_STRENGTHENED ? row.processing.HEAT_STRENGTHENED.split('\n').map((line, index) => 
                            index === 1 ? 
                              `<div style="color: #1976d2; padding: 4px 8px; border-radius: 4px; display: inline-block;">${line}</div>` :
                              `${line}${index === 0 ? '<br/>' : ''}`
                          ).join('') : ''}
                        </td>
                        <td style="text-align: center; padding: 4px 8px;">
                          ${row.processing.TEMPERED ? row.processing.TEMPERED.split('\n').map((line, index) => 
                            index === 1 ? 
                              `<div style="color: #1976d2; padding: 4px 8px; border-radius: 4px; display: inline-block;">${line}</div>` :
                              `${line}${index === 0 ? '<br/>' : ''}`
                          ).join('') : ''}
                        </td>
                        ${index === 0 || pageRows[index - 1].group?.product1 !== group.product1 ? `
                          <td rowspan="${pageRows.filter(r => r.group?.product1 === group.product1).length}" style="text-align: center; padding: 4px 8px;">
                            ${group.processing.LAMINATED ? group.processing.LAMINATED.split('\n').map((line, index) => 
                              index === 1 ? 
                                `<div style="color: #1976d2; padding: 4px 8px; border-radius: 4px; display: inline-block;">${line}</div>` :
                                `${line}${index === 0 ? '<br/>' : ''}`
                            ).join('') : ''}
                          </td>
                        ` : ''}
                        ${index === 0 || pageRows[index - 1].group?.product1 !== group.product1 ? `
                          <td rowspan="${pageRows.filter(r => r.group?.product1 === group.product1).length}" style="text-align: center; padding: 4px 8px;">
                            ${group.processing.INSULATED_GLASS_UNIT ? group.processing.INSULATED_GLASS_UNIT.split('\n').map((line, index) => 
                              index === 1 ? 
                                `<div style="color: #1976d2; padding: 4px 8px; border-radius: 4px; display: inline-block;">${line}</div>` :
                                `${line}${index === 0 ? '<br/>' : ''}`
                            ).join('') : ''}
                          </td>
                        ` : ''}
                      </tr>
                    `;
                  } else {
                    return `
                      <tr>
                        ${index === 0 || pageRows[index - 1].label !== row.label ? `
                          <td rowspan="${pageRows.filter(r => r.label === row.label).length}" style="padding: 4px 8px;">${row.label}</td>
                        ` : ''}
                        <td style="padding: 4px 8px;">${row.no}</td>
                        <td style="padding: 4px 8px;">${row.product1}</td>
                        <td style="text-align: center; padding: 4px 8px;">
                          <div style="color: #1976d2; display: inline-block; text-align: center; width: 100%;">
                            ${row.product2}
                          </div>
                        </td>
                        ${index === 0 || pageRows[index - 1].label !== row.label ? `
                          <td colspan="4" rowspan="${pageRows.filter(r => r.label === row.label).length}" style="text-align: center; color: rgba(0, 0, 0, 0.6); border-left: none; border-right: none; padding: 4px 8px;">
                            해당없음
                          </td>
                        ` : ''}
                      </tr>
                    `;
                  }
                }).join('')}
              </tbody>
            </table>
          `).join('');
        })()}
      </div>
    `;
    
    // 문서 테이블 HTML 생성
    const documentTableHtml = `
      <div class="page-break" style="page-break-before: always;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div style="font-size: 1.5rem; font-weight: bold;">2. 공급업체별 첨부서류</div>
          <div style="font-size: 0.875rem; text-align: right; white-space: nowrap; display: flex; align-items: center;">
            <span style="margin-right: 8px;">● : 첨부</span>
            <span style="margin-right: 8px;">▲ : 만료</span>
            <span style="margin-right: 8px;">○ : 성능확인서</span>
            <span style="margin-right: 8px;">× : 없음(필수)</span>
            <span style="margin-right: 8px;">- : 없음(선택)</span>
          </div>
        </div>
        ${(() => {
          const ROWS_PER_PAGE = 20; // A4 가로 기준 한 페이지당 표시할 행 수
          const pages = [];
          let currentPage = [];
          let currentRowCount = 0;
          let currentLabel = null;
          let remainingRows = [...documentTableData.rows];

          // 페이지 단위로 데이터 분할 (구분 고려)
          while (remainingRows.length > 0) {
            const row = remainingRows[0];
            const isNewLabel = row.label !== currentLabel;
            
            // 새로운 구분이 시작되는 경우
            if (isNewLabel) {
              // 현재 페이지가 비어있지 않고, 새로운 구분이 페이지 중간에 오면
              if (currentPage.length > 0 && currentRowCount >= ROWS_PER_PAGE) {
                pages.push(currentPage);
                currentPage = [row];
                currentRowCount = 1;
                remainingRows.shift();
              } else {
                // 마지막 구분이 페이지 끝에 걸리는지 확인
                const remainingRowsInLabel = remainingRows.filter(r => r.label === row.label).length;
                if (currentRowCount + remainingRowsInLabel > ROWS_PER_PAGE && currentPage.length > 0) {
                  pages.push(currentPage);
                  currentPage = [row];
                  currentRowCount = 1;
                } else {
                  currentPage.push(row);
                  currentRowCount++;
                }
                remainingRows.shift();
              }
              currentLabel = row.label;
            } else {
              // 같은 구분 내에서 페이지가 가득 찬 경우
              if (currentRowCount >= ROWS_PER_PAGE) {
                // 현재 구분의 남은 행 수 계산
                const remainingRowsInCurrentLabel = remainingRows.filter(r => r.label === currentLabel).length;
                
                // 현재 구분이 페이지보다 긴 경우
                if (remainingRowsInCurrentLabel > 0) {
                  // 현재 페이지에 헤더를 포함한 구분 시작 행 추가
                  pages.push(currentPage);
                  currentPage = [row];
                  currentRowCount = 1;
                } else {
                  // 다음 구분으로 넘어가기
                  pages.push(currentPage);
                  currentPage = [row];
                  currentRowCount = 1;
                }
                remainingRows.shift();
              } else {
                currentPage.push(row);
                currentRowCount++;
                remainingRows.shift();
              }
            }
          }

          // 마지막 페이지 추가
          if (currentPage.length > 0) {
            pages.push(currentPage);
          }

          // 각 페이지별 테이블 HTML 생성
          return pages.map((pageRows, pageIndex) => `
            ${pageIndex > 0 ? '<div style="page-break-before: always;"></div>' : ''}
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
              <thead>
                <tr>
                  ${documentTableData.headers.map(header => `
                    <th colspan="${header.colspan || 1}" rowspan="${header.rowspan || 1}" 
                        style="font-weight: bold; text-align: center; width: ${header.width}; padding: 4px 8px;">
                      ${replaceNewlineWithBr(header.label)}
                    </th>
                  `).join('')}
                </tr>
                <tr>
                  ${documentTableData.headers.map(header => 
                    header.subHeaders?.map(subHeader => `
                      <th colspan="${subHeader.colspan || 1}" style="font-weight: bold; text-align: center; width: ${subHeader.width}; padding: 4px 8px;">
                        ${replaceNewlineWithBr(subHeader.label)}
                      </th>
                    `).join('') || ''
                  ).join('')}
                </tr>
              </thead>
              <tbody>
                ${pageRows.map((row, index) => `
                  <tr>
                    ${index === 0 || pageRows[index - 1].label !== row.label ? `
                      <td style="text-align: center; padding: 4px 8px;" rowspan="${pageRows.filter(r => r.label === row.label).length}">${replaceNewlineWithBr(row.label)}</td>
                    ` : ''}
                    ${row.companyRowspan > 0 ? `
                      <td style="padding: 4px 8px;" rowspan="${row.companyRowspan}">${row.company}</td>
                    ` : ''}
                    ${row.companyRowspan > 0 ? (
                      row.documentCells.map((cell, i) => `
                        <td style="${Array.isArray(cell) ? '' : 'text-align: center;'} line-height: 1.2; padding: 4px 8px;" rowspan="${row.companyRowspan}">
                          ${Array.isArray(cell) ? (
                            cell.map(doc => `
                              ${doc.hasPath ? `<div style="margin: 0;">• ${doc.label}</div>` : ''}
                            `).join('')
                          ) : (
                            `<span>
                              ${cell.hasPath ? (cell.valid || cell.validYN ? '●' : '▲') : (cell.required ? '×' : '-')}
                            </span>`
                          )}
                        </td>
                      `).join('')
                    ) : ''}
                    ${row.label === '시공업체' ? `
                      <td colspan="6" rowspan="${row.companyRowspan}" style="text-align: center; padding: 4px 8px;">해당없음</td>
                    ` : `
                      <td style="border: 1px solid rgba(0, 0, 0, 0.12); padding: 4px 8px;">
                        <div style="font-size: 0.875rem;">${row.productName.name}</div>
                      </td>
                      ${(() => {
                        const currentIndex = pageRows.findIndex(r => r.id === row.id);
                        const sameCertificationRows = [];
                        let i = currentIndex;
                        
                        while (i < pageRows.length && 
                               pageRows[i].productName?.g04docuGCertificationName === row.productName?.g04docuGCertificationName) {
                          sameCertificationRows.push(pageRows[i]);
                          i++;
                        }
                        
                        if (currentIndex === 0 || 
                            pageRows[currentIndex - 1].productName?.g04docuGCertificationName !== row.productName?.g04docuGCertificationName) {
                          return `
                            <td style="border: 1px solid rgba(0, 0, 0, 0.12); text-align: center; padding: 2px 8px;" rowspan="${sameCertificationRows.length}"  width="12%">
                              ${row.productName?.g04docuGCertificationName ? (
                                row.productName.g04docuGCertificationName.includes('[') ? (
                                  `<div style="font-size: 0.875rem;">
                                    <div style="white-space: nowrap; margin-bottom: -2px;">
                                      [ ${row.productName.g04docuGCertificationName.match(/\[(.*?)\]/)[1].trim()} ]
                                    </div>
                                    ${row.productName.g04docuGCertificationName.replace(/\[.*?\]/, '').trim()}
                                  </div>`
                                ) : row.productName.g04docuGCertificationName
                              ) : '-'}
                            </td>
                            <td style="border: 1px solid rgba(0, 0, 0, 0.12); text-align: center; padding: 4px 8px;" rowspan="${sameCertificationRows.length}" width="5%">
                              ${row.productName?.hasCertificationDoc ? '●' : '×'}
                            </td>
                          `;
                        }
                        return '';
                      })()}
                      <td style="border: 1px solid rgba(0, 0, 0, 0.12); text-align: center; padding: 4px 8px;">
                        ${row.productName.hasDoc ? 
                          (row.productName.isValid || row.productName.isValidYN ? '●' : '▲') :
                          (row.productName.hasPerformanceDoc ? '○' : '×')}
                      </td>
                      <td style="border: 1px solid rgba(0, 0, 0, 0.12); text-align: center; padding: 4px 8px;">
                        ${row.productName.hasComparisonDoc
                          ? (row.productName.hasDoc
                              ? ((row.productName.isValid || row.productName.isValidYN) ? '●' : '▲')
                              : '▲')
                          : '-'}
                      </td>
                      ${(() => {
                        const currentIndex = pageRows.findIndex(r => r.id === row.id);
                        const sameCompanyRows = [];
                        let i = currentIndex;
                        while (i < pageRows.length && pageRows[i].company === row.company) {
                          sameCompanyRows.push(pageRows[i]);
                          i++;
                        }
                        if (currentIndex === 0 || pageRows[currentIndex - 1].company !== row.company) {
                          // 기타 문서: 첨부된 문서만 출력, 없으면 '-'
                          const attachedEtcDocs = (row.etcDocs && row.etcDocs.length > 0)
                            ? row.etcDocs.filter(doc => doc.hasPath)
                            : [];
                          return `
                          <td
                            align="center"
                            rowspan="${sameCompanyRows.length}"
                            style="text-align: ${attachedEtcDocs.length > 0 ? 'left' : 'center'}; line-height: 1.2; padding: 4px 8px;"
                          >
                            ${attachedEtcDocs.length > 0
                              ? attachedEtcDocs.map(doc => `<div style="margin: 0;">• ${doc.label}</div>`).join('')
                              : '-'}
                          </td>`;
                        }
                        return '';
                      })()}
                    `}
                  </tr>
                `).join('')}
              </tbody>
            </table>
          `).join('');
        })()}
      </div>
    `;

    // 최종 HTML 생성
    const fullTableHtmlMaterial = `
      <html>
        <head>
          <meta charset="UTF-8">
          <style type="text/css">
            html { 
              font-family: Pretendard, 나눔고딕, NanumGothic;
              font-size: 10px !important;
            }
            body {
              margin: 0px;
              font-size: 10px !important;
            }
            .page-break {page-break-before: always;}
            table, th, td {
              font-size: 10px !important;
              border: 1px solid rgba(0, 0, 0, 0.12);
              border-collapse: collapse;
              padding: 2px;
              margin: 0;
            }

            tr {
              page-break-inside: avoid;
            }

            thead {
              display: table-header-group;
            }

            @page {
              margin: 12px;
              size: A4 landscape;
            }
          </style>
        </head>
        <body>
          <div>
            ${materialTableHtml}
          </div>
        </body>
      </html>`;

    const fullTableHtmlDocument = `
      <html>
        <head>
          <meta charset="UTF-8">
          <style type="text/css">
            html { 
              font-family: Pretendard, 나눔고딕, NanumGothic;
              font-size: 10px !important;
            }
            body {
              margin: 0px;
              font-size: 10px !important;
            }
            .page-break {page-break-before: always;}
            table, th, td {
              font-size: 10px !important;
              border: 1px solid rgba(0, 0, 0, 0.12);
              border-collapse: collapse;
              padding: 2px;
              margin: 0;
            }

            tr {
              page-break-inside: avoid;
            }

            thead {
              display: table-header-group;
            }

            @page {
              margin: 12px;
              size: A4 landscape;
            }
          </style>
        </head>
        <body>
          <div>
            ${documentTableHtml}
          </div>
        </body>
      </html>`;
    
    // console.log(formatHtml(fullTableHtmlMaterial))
    // console.log(formatHtml(fullTableHtmlDocument))
    
    return [fullTableHtmlMaterial, fullTableHtmlDocument];
  };

  const handleMaterialApprovalDialogClose = () => {
    setMaterialApprovalDialogOpen(false);
  }

  const handleUpdateItems = (id, newData) => {
    console.log('handleUpdateItems 호출:', id, newData);
    
    // 성적서 교체 선택인 경우
    if (newData.type === 'substitute_document_selected') {
      console.log('성적서 교체 선택됨:', newData);
      
      // 업데이트된 itemsWithDocus로 상태 업데이트
      if (newData.updatedItemsWithDocus) {
        setItemsWithDocus(newData.updatedItemsWithDocus);
        console.log('itemsWithDocus 업데이트 완료');
        console.log('updatedItemsWithDocus:', newData.updatedItemsWithDocus);
      }
      return;
    }
    
    // 성적서 삭제인 경우
    if (newData.type === 'substitute_document_removed') {
      console.log('성적서 삭제됨:', newData);
      
      // 업데이트된 itemsWithDocus로 상태 업데이트
      if (newData.updatedItemsWithDocus) {
        setItemsWithDocus(newData.updatedItemsWithDocus);
        console.log('itemsWithDocus 삭제 업데이트 완료');
        console.log('updatedItemsWithDocus:', newData.updatedItemsWithDocus);
      }
      return;
    }
    
    // 시험성과대비표 업데이트인 경우
    if (newData.type === 'comparison_document_updated') {
      console.log('시험성과대비표 업데이트됨:', newData);
      
      // 업데이트된 itemsWithDocus로 상태 업데이트
      if (newData.updatedItemsWithDocus) {
        setItemsWithDocus(newData.updatedItemsWithDocus);
        console.log('itemsWithDocus 시험성과대비표 업데이트 완료');
        console.log('updatedItemsWithDocus:', newData.updatedItemsWithDocus);
      }
      return;
    }
    
    // 기타 업데이트 로직 (향후 확장용)
    console.log(`${id} 노드를 ${newData}로 업데이트해야 합니다.`);
  };

  // 문서 선택 핸들러
  const handleDocumentSelected = (documentInfo) => {
    setSelectedDocument(documentInfo);
  };

  return (
    <>
      <Box sx={{ height: 'calc(100vh - 120px)' }}>
        <Stack direction="row" sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
          {/* actions */}
          <Box>
            {
              from?.source === "GProjectG04GeneratorDialog" && (
                <>
                  <Button
                    variant={"contained"}
                    startIcon={<PostAdd />}
                    onClick={handleClickGenerate}
                  >
                    {"생성"}
                  </Button>
                  {
                    closedGClientList.length > 0 && (
                      <Button
                        variant={"outlined"}
                        startIcon={<LockOpen />}
                        onClick={() => {
                          if (documentViewerDrawerOpen) {
                            closeDocumentViewer();
                          }

                          refreshClosedGClients();
                          setOpenRequest(true);
                        }} sx={{ ml: 1 }}
                      >
                        {"열람요청"}
                      </Button>
                    )
                  }
                  
                </>
              )
            }
            {
              from?.source === "G04docuMaterialApprovalDialog" && (
                <Button 
                  variant="outlined" 
                  onClick={() => handleClickViewMaterialApproval(from.params.g04docuMaterialApproval.documentPath)}
                  startIcon={<Visibility />}
                >
                  {"자재승인서"}
                </Button>
              )
            }
            <Button
              variant="outlined"
              startIcon={<TableChart />}
              onClick={handleClickViewMateialApprovalSummary}
              sx={{ ml: 1 }}
            >
              {"요약정보"}
            </Button>
            {
              from?.source === "GProjectG04GeneratorDialog" && (
                <Button
                  variant="outlined"
                  startIcon={<FactCheck />}
                  onClick={() => setTestReportManagerOpen(true)}
                  sx={{ ml: 1 }}
                >
                  {"성적서/시험성과대비표"}
                  <StyledTooltip
                    title={
                      <Box>
                        <Typography variant="h6">다음과 같은 작업을 합니다.</Typography><br />
                        <Typography variant="subtitle1">1. 성적서가 없는 경우 대체성적서를 첨부합니다.</Typography>
                        <Typography variant="subtitle1">2. 여러 개의 후보 성적서 중 프로젝트에 맞는 성적서를 선택합니다.</Typography>
                        <Typography variant="subtitle1">3. 시험성과대비표가 없는 경우 시험성과대비표를 만듭니다.</Typography>
                        <Typography variant="subtitle1">4. 시방규격에 따른 시험성과대비표를 만듭니다.</Typography>
                      </Box>
                    }
                    placement="right"
                    sx={tooltipTop}
                  >
                    <Help 
                      sx={{ 
                        fontSize: 18,
                        ml: 2,
                        color: 'rgba(0, 0, 0, 0.5)'
                      }}
                    />
                  </StyledTooltip>
                </Button>
              )
            }
          </Box>
          
          <Box>
            <Stack direction="row" spacing={3} alignItems="center">
              {/* filtering */}
              <ToggleButtonGroup size="small" exclusive color="primary">
                <ToggleButton
                  value="all"
                  selected={showAll}
                  onChange={handleAllToggle}
                >
                  {"전체"}
                </ToggleButton>
                <ToggleButton
                  value="missingDocs"
                  selected={showOnlyMissingDocs}
                  onChange={handleMissingDocsToggle}
                >
                  {"서류없음"}
                </ToggleButton>
                <ToggleButton
                  value="expiredDocs"
                  selected={showOnlyExpiredDocs}
                  onChange={handleExpiredDocsToggle}
                >
                  {"만료일 경과"}
                </ToggleButton>
              </ToggleButtonGroup>
              {/* {
                !gsupplyConfirm && (
                  <ToggleButtonGroup
                    size="medium"
                    exclusive
                    value={viewMode}
                    onChange={handleViewModeChange}
                    sx={{
                      '& .MuiToggleButton-root': {
                        px: 2,
                        py: 1,
                      }
                    }}
                  >
                    <ToggleButton value="tree">
                      <Tooltip title="트리뷰">
                        <AccountTree sx={{ fontSize: 28 }} />
                      </Tooltip>
                    </ToggleButton>
                    <ToggleButton value="table">
                      <Tooltip title="테이블뷰">
                        <TableChart sx={{ fontSize: 28 }} />
                      </Tooltip>
                    </ToggleButton>
                  </ToggleButtonGroup>
                )
              } */}
            </Stack>
          </Box>
        </Stack>

        <Box sx={{ mb: 1 }}>
          <DocumentStatusLegend />
        </Box>

        {/* 목차 : 트리뷰 또는 테이블뷰 */}
        {viewMode === 'tree' ? (
          <>
            <GProjectG04ContentTreeView
              from={from}
              crudMode={crudMode}
              itemsWithDocus={itemsWithDocus}
              filteredItems={filteredItems}
              selected={selectedProps}
              onSelect={onSelectProps}
              disableMultiParentSelection={disableMultiParentSelection}
              handleClickViewEachDoc={handleClickViewEachDoc}
              handleClickInfoMateialApprovalSummary={handleClickInfoMateialApprovalSummary}
              handleClickViewSummary={handleClickViewSummary}
              handleClickAddSubstituteTestDoc={handleClickAddSubstituteTestDoc}
              reGenerate={reGenerate}
              onDocumentSelected={handleDocumentSelected}
            />
            {/* 선택된 문서 정보 표시 */}
            {selectedDocument && (
              <Box
                sx={{
                  mt: 1,
                  p: 1,
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                  backgroundColor: '#f8f9fa',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Circle sx={{ 
                  width: 12, 
                  height: 12, 
                  color: selectedDocument.color 
                }} />
                <Typography variant="caption" sx={{ color: '#666' }}>
                  선택된 문서:
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {selectedDocument.name}
                </Typography>
                <Typography variant="caption" sx={{ color: '#666', ml: 1 }}>
                  ({selectedDocument.type} - {selectedDocument.status})
                </Typography>
              </Box>
            )}
          </>
        ) : (
          <>
            <GProjectG04ContentTableView
              from={from}
              crudMode={crudMode}
              gproject={gproject}
              itemsWithDocus={itemsWithDocus}
              filteredItems={filteredItems}
              selected={selectedProps}
              onSelect={onSelectProps}
              disableMultiParentSelection={disableMultiParentSelection}
              handleClickViewEachDoc={handleClickViewEachDoc}
              handleClickViewSummary={handleClickViewSummary}
              handleClickAddSubstituteTestDoc={handleClickAddSubstituteTestDoc}
              reGenerate={reGenerate}
              materialTableData={materialTableData}
              documentTableData={documentTableData}
              onDocumentSelected={handleDocumentSelected}
              // onTableHtmlGenerated={generateTableHtml}
            />
            {/* 선택된 문서 정보 표시 */}
            {selectedDocument && (
              <Box
                sx={{
                  mt: 1,
                  p: 1,
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                  backgroundColor: '#f8f9fa',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Circle sx={{ 
                  width: 12, 
                  height: 12, 
                  color: selectedDocument.color 
                }} />
                <Typography variant="caption" sx={{ color: '#666' }}>
                  선택된 문서:
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {selectedDocument.name}
                </Typography>
                <Typography variant="caption" sx={{ color: '#666', ml: 1 }}>
                  ({selectedDocument.type} - {selectedDocument.status})
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>

      {/* 서류 생성 다이얼로그 */}
      <Dialog
        open={open}
        onClose={handleDialogClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        scroll="body"
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleDialogClose}
        >
          <div id="dialog-position">
            {"생성"}
          </div>
        </DialogTitleClose>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ color: "#1565c0", fontSize: 14 }}>
              &#8251;&nbsp;{"서류의 양과 시스템 상황에 따라 수 분이 소요될 수 있습니다."}
            </Grid>
            <Grid item xs={12}>
              <FormInputText
                name={"fileName"}
                control={control}
                label={"파일명"}
                placeholder={"파일명이 없으면 프로젝트의 '현장명+날짜정보.pdf'로 자동 생성됩니다."}
              />
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardHeader
                  titleTypographyProps={{ variant: 'subtitle1' }}
                  title={<><Typography sx={{ mb: 1 }}>
                    문서포함 여부 선택 {<span style={{ color: '#1565c0', fontSize: 14 }}>&nbsp;기본적으로 유효한 문서(만료일 내 + 첨부된 문서)만 포함됩니다.</span>}
                  </Typography></>}
                  sx={{ bgcolor: "#eaeaea" }}
                />
                <CardContent>
                  <Grid container spacing={2}>
                    {[
                      {
                        checked: includeExpiredDocs,
                        handler: handleIncludeExpiredDocs,
                        title: "만료일 경과 문서",
                        height: 24
                      },
                      {
                        checked: includeUnattachedDocs,
                        handler: handleIncludeUnattachedDocs,
                        title: "첨부되지 않은 문서",
                        subtitle: "(목차표시, 빈문서 발급)",
                        height: 40
                      },
                      {
                        checked: includeGTestComparisons,
                        handler: handleIncludeGTestComparisons,
                        title: "시험성과대비표",
                        height: 24
                      }
                    ].map((item, index) => (
                      <Grid item xs={4} key={index}>
                        <Box
                          onClick={() => item.handler(null, !item.checked)}  // 첫 번째 인자는 null, 두 번째 인자로 checked 값 전달
                          sx={{ 
                            cursor: 'pointer',
                            height: '100%',
                            minHeight: 120,
                            bgcolor: item.checked ? '#E3EEFA' : 'white',
                            position: 'relative',
                            borderRadius: '3px',
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 2,
                            borderColor: item.checked ? '#1976d2' : '#e0e0e0',
                            transition: 'all 0.3s ease',
                            '&:hover': { 
                              borderColor: '#1976d2',
                              transform: 'translateY(-2px)',
                              boxShadow: 2
                            },
                            '&::before': {
                              content: '""',
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              borderStyle: 'solid',
                              borderWidth: '0 20px 20px 0',
                              borderColor: item.checked ? '#1976d2 transparent' : '#f5f5f5 transparent',
                              transition: 'all 0.3s ease'
                            }
                          }}
                        >
                          <Checkbox
                            checked={Boolean(item.checked)}
                            onChange={(e) => {
                              e.stopPropagation();
                              item.handler(e, e.target.checked);  // 이벤트와 checked 값 전달
                            }}
                            icon={<CheckCircle />}
                            checkedIcon={<CheckCircle />}
                            sx={{ 
                              position: 'absolute',
                              top: 8,
                              left: 8,
                              padding: 0,
                              '& .MuiSvgIcon-root': { 
                                fontSize: 20,
                                color: item.checked ? '#1976d2' : '#e0e0e0'
                              }
                            }}
                          />

                          {/* 제목 영역 */}
                          <Box sx={{ 
                            height: item.height,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}>
                            <Typography 
                              variant="body1" 
                              sx={{ 
                                fontWeight: 500,
                                color: item.checked ? '#1976d2' : '#424242',
                                textAlign: 'center',
                                transition: 'all 0.3s ease',
                                lineHeight: 1.2
                              }}
                            >
                              {item.title}
                            </Typography>

                            {item.subtitle && (
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: item.checked ? '#1976d2' : '#757575',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                {item.subtitle}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>

                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardHeader
                  titleTypographyProps={{ variant: 'subtitle1' }}
                  title={"원본대조필"}
                  sx={{ bgcolor: "#eaeaea" }}
                />
                <CardContent>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={12}>
                      {"날인정보 "}
                      <span style={{ fontWeight: 'bold', color: '#1976d2' }}>{"원본대조필과 인감, 현장정보"}</span>
                      {" 를 문서에 날인합니다."}
                    </Grid> */}
                    <Grid item xs={12}>
                      <ToggleButtonGroup
                        color="primary"
                        value={signOption}
                        exclusive
                        // size="small"
                        onChange={handleChangeSignOption}
                      >
                        <ToggleButton value="CERTIFIED_TRUE_COPY_AND_SIGN">{"원본대조필 인쇄"}</ToggleButton>
                        <ToggleButton value="NONE">{"원본대조필 인쇄안함"}</ToggleButton>
                      </ToggleButtonGroup>  
                    </Grid>
                    <Grid item xs={12} sx={{ 
                      opacity: signOption === 'NONE' ? 0.5 : 1,
                      pointerEvents: signOption === 'NONE' ? 'none' : 'auto',
                      filter: signOption === 'NONE' ? 'blur(2px)' : 'none', // 이 줄을 추가
                    }}>
                      <Stack direction="row" display="flex" justifyContent={"flex-start"} alignItems="center">
                        <Typography variant="body2">{"원본문서에 직인정보가 없을 경우, 우리회사의 직인으로 대체 날인합니다."}</Typography>
                        <Checkbox
                          onChange={handleChangeMyCertified}
                          checked={myCertified}
                          sx={{ mt: -0.4 }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12} sx={{ 
                      opacity: signOption === 'NONE' ? 0.5 : 1,
                      pointerEvents: signOption === 'NONE' ? 'none' : 'auto',
                      filter: signOption === 'NONE' ? 'blur(2px)' : 'none', // 이 줄을 추가
                    }}>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Grid container>
                            <Grid xs={12} display="flex" justifyContent={"center"} alignItems="center">
                              <TableContainer>
                                <Table aria-label="원본대조필 정보" sx={{ width: 400 }} size="small">
                                  <TableBody>
                                    <TableRow>
                                      <TableCell colspan={2} sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, borderRight: 1,width: '90%', fontSize: '20px', color: '#664AA0' }}>
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                          {"원본대조필 (인)"}
                                        </Box>
                                      </TableCell>
                                      <TableCell sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, color: '#664AA0', p: 0 }}>
                                        {
                                          URLThumbnail && (<Box sx={{ width: 60, height: 60 }} display="flex" justifyContent={"center"} alignItems={"center"}>
                                            <img src={URLThumbnail} alt="이미지 미리보기" style={{ maxWidth: '58px' }} />
                                          </Box>)
                                        }
                                      </TableCell>
                                    </TableRow>
                                    {/* 제공사 행 */}
                                    <TableRow>
                                      <TableCell sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, borderRight: 1, color: '#664AA0', width: '30%' }}>
                                        <Grid container>
                                          <Grid item xs={10}>
                                            <FormInputText
                                              autoComplete="supplierLabel"
                                              name={"supplierLabel"}
                                              control={control}
                                              required
                                              fullWidth
                                              errorStyle={{ message: false, border: true }}
                                              variant="standard"
                                              InputProps={{
                                                disableUnderline: true,
                                                readOnly: true,
                                              }}
                                              inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                            />
                                          </Grid>
                                          <Grid item xs={2}>
                                            {" : "}
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                      <TableCell colSpan={2} sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, color: '#664AA0' }}>
                                        <FormInputText
                                          autoComplete="supplier"
                                          name={"supplier"}
                                          control={control}
                                          required
                                          fullWidth
                                          errorStyle={{ message: false, border: true }}
                                          variant="standard"
                                          inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                          InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                          }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                    {/* 제출처 행 */}
                                    <TableRow>
                                      <TableCell sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, borderRight: 1, width: '30%', fontSize: '14px', color: '#664AA0' }}>
                                        <Grid container>
                                          <Grid item xs={10}>
                                            <FormInputText
                                              name={"recipientLabel"}
                                              control={control}
                                              variant="standard"
                                              inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                              InputProps={{
                                                disableUnderline: true,
                                                readOnly: true,
                                              }}
                                            />
                                          </Grid>
                                          <Grid item xs={2}>
                                            {" : "}
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                      <TableCell colSpan={2} sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, fontSize: '14px', color: '#664AA0' }}>
                                        <FormInputText
                                          name={"recipient"}
                                          control={control}
                                          variant="standard"
                                          inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                          InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                          }}
                                          error={emptyRecipient}
                                          errorStyle={{ message: false, border: true }}
                                          // onChange={handleChangeRecipient}
                                        />
                                      </TableCell>
                                    </TableRow>
                                    {/* 현장명 행 */}
                                    <TableRow>
                                      <TableCell sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, borderRight: 1, width: '30%', fontSize: '14px', color: '#664AA0' }}>
                                        <Grid container>
                                          <Grid item xs={10}>
                                            <FormInputText
                                              name={"siteLabel"}
                                              control={control}
                                              variant="standard"
                                              inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                              InputProps={{
                                                disableUnderline: true,
                                                readOnly: true,
                                              }}
                                            />
                                          </Grid>
                                          <Grid item xs={2}>
                                            {" : "}
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                      <TableCell colSpan={2} sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, fontSize: '14px', color: '#664AA0' }}>
                                        <FormInputText
                                          name={"site"}
                                          control={control}
                                          variant="standard"
                                          inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                          InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                          }}
                                          error={emptySite}
                                          errorStyle={{ message: false, border: true }}
                                          onChange={handleChangeSite}
                                        />
                                      </TableCell>
                                    </TableRow>
                                    {/* 안내문구 행 */}
                                    <TableRow>
                                      <TableCell colSpan={3} sx={{ border: 1, borderColor: '#664AA0' }}>
                                        <FormInputText
                                          name={"phrase"}
                                          control={control}
                                          // label={"문구"}
                                          // fullWidth
                                          // multiline // multiline이 들어가면 색상 변경이 안됨???
                                          // maxRows={5}
                                          // onChange={handleChangePhrase}
                                          variant="standard"
                                          InputProps={{
                                            disableUnderline: true,
                                            readOnly: true,
                                          }}
                                          inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <FormInputText
                name={"comments"}
                control={control}
                label={"설명"}
                multiline
                maxRows={5}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            variant="contained"
            // onClick={handleClickCheckedDoc}
            startIcon={<PostAdd />}
            loading={loading}
            onClick={handleSubmit(onSubmit)}
          >
            {"작성"}
          </LoadingButton>
          <Button
            onClick={handleDialogClose}
          >
            {"닫기"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 알림 다이얼로그 */}
      <AlertDialog
        alertInfo={alertInfo}
        setAlertInfo={setAlertInfo}
        setLoading={setLoading}
      />

      {/* 자재 승인 요약 다이얼로그 */}
      <Dialog
        fullScreen={true}
        open={materialApprovalDialogOpen}
        onClose={handleMaterialApprovalDialogClose}
        maxWidth="xl"
        scroll="body"
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleMaterialApprovalDialogClose}
          fullScreen={true}
          color="white"
          style={{ backgroundColor: "#1976d2" }}
        >
          <div id="dialog-position">
            {"자재승인서 요약"}
          </div>
        </DialogTitleClose>
        <DialogContent>
          <GProjectG04ContentTableView
            from={from}
            crudMode={crudMode}
            gproject={gproject}
            itemsWithDocus={itemsWithDocus}
            filteredItems={filteredItems}
            selected={selectedProps}
            onSelect={onSelectProps}
            disableMultiParentSelection={disableMultiParentSelection}
            handleClickViewEachDoc={handleClickViewEachDoc}
            handleClickViewSummary={handleClickViewSummary}
            handleClickAddSubstituteTestDoc={handleClickAddSubstituteTestDoc}
            reGenerate={reGenerate}
            // onTableHtmlGenerated={generateTableHtml}
            materialTableData={materialTableData}
            documentTableData={documentTableData}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMaterialApprovalDialogClose}>닫기</Button>
        </DialogActions>
      </Dialog>
      
      <TestReportManagerDialog
        open={testReportManagerOpen}
        onClose={() => setTestReportManagerOpen(false)}
        gproject={gproject}
        itemsWithDocus={itemsWithDocus}
        selectedProps={selectedProps}
        onUpdate={handleUpdateItems}
      />
    </>
  );
};

export default GProjectG04ContentView;

